import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.surveys');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-surveys',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.surveys/view.scss */
@charset "UTF-8";
.ops-page {
  --ops-ink: #25221f;
  --ops-muted: #77736c;
  --ops-line: #ddd9d1;
  --ops-line-soft: #ece9e3;
  --ops-soft: #f6f7f3;
  --ops-olive: #30491f;
  --ops-green: #52732e;
  --ops-orange: #b8521b;
  --ops-canvas: var(--ro-canvas, #fafbf8);
  min-height: 100%;
  color: var(--ops-ink);
  background: var(--ops-canvas);
}

.ops-page *,
.ops-page *::before,
.ops-page *::after,
.ops-modal-backdrop *,
.ops-modal-backdrop *::before,
.ops-modal-backdrop *::after {
  box-sizing: border-box;
}

.ops-page button,
.ops-page input,
.ops-page select,
.ops-page textarea,
.ops-modal-backdrop button,
.ops-modal-backdrop input,
.ops-modal-backdrop select,
.ops-modal-backdrop textarea {
  font: inherit;
}

.ops-shell {
  width: min(100%, 1500px);
  margin: 0 auto;
  padding-right: 32px;
  padding-left: 32px;
}

.ops-header {
  z-index: 2;
  border-bottom: 1px solid #d8d5ce;
  background: #fff;
}

.ops-heading {
  min-width: 0;
  animation: ops-fade-up 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #817d75;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.ops-eyebrow i,
.ops-result-meta > div i {
  width: 3px;
  height: 3px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #c5c0b8;
}

.ops-eyebrow strong {
  color: var(--ops-orange);
  font-weight: 700;
}

.ops-heading h1 {
  margin: 7px 0 0;
}

.ops-heading > p {
  margin: 7px 0 0;
  color: #706c65;
  font-size: 13px;
  line-height: 1.45;
}

.ops-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  animation: ops-fade-up 500ms 70ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-header-status {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #d9d7d0;
  border-radius: 10px;
  background: #fafaf8;
  color: #5f6f50;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-header-status i {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #587b34;
}

.ops-header-status i::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(88, 123, 52, 0.26);
  border-radius: inherit;
  content: "";
  animation: ops-live 2.4s ease-out infinite;
}

.ops-primary-button {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 17px;
  border: 0;
  background: var(--ops-olive);
  color: #fff;
  box-shadow: 0 8px 20px rgba(48, 73, 31, 0.17);
  cursor: pointer;
  transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.ops-primary-button svg {
  width: 16px;
  height: 16px;
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-primary-button:hover {
  background: #3d592a;
  box-shadow: 0 11px 24px rgba(48, 73, 31, 0.22);
  transform: translateY(-1px);
}

.ops-primary-button:hover svg {
  transform: rotate(90deg);
}

.ops-primary-button:active {
  transform: translateY(0) scale(0.98);
}

.ops-content {
  display: grid;
  gap: 22px;
  padding-top: 24px;
  padding-bottom: 32px;
}

.ops-summary,
.ops-panel {
  overflow: hidden;
  border: 1px solid #d9d6cf;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 13px 32px rgba(42, 40, 35, 0.06), 0 2px 5px rgba(42, 40, 35, 0.03);
}

.ops-summary {
  min-height: 82px;
  display: grid;
  grid-template-columns: 245px minmax(0, 1fr);
  background: linear-gradient(105deg, #fff 0%, #fbfbf8 100%);
  animation: ops-panel-in 540ms 100ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-summary__intro {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
}

.ops-summary__icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 11px;
  background: #edf2e8;
  color: #47672d;
}

.ops-summary__icon svg {
  width: 20px;
  height: 20px;
}

.ops-summary__intro strong {
  display: block;
  color: #34312d;
  font-size: 13px;
  font-weight: 700;
}

.ops-summary__intro p {
  margin: 5px 0 0;
  color: #8b877f;
  font-size: 12px;
  white-space: nowrap;
}

.ops-summary__grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ops-stat {
  --stat-color: #8a9ab0;
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
  animation: ops-stat-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-stat:nth-child(1) {
  animation-delay: 170ms;
}

.ops-stat:nth-child(2) {
  animation-delay: 220ms;
}

.ops-stat:nth-child(3) {
  animation-delay: 270ms;
}

.ops-stat:nth-child(4) {
  animation-delay: 320ms;
}

.ops-stat:last-child {
  border-right: 0;
}

.ops-stat::before {
  position: absolute;
  top: 20px;
  right: 18px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--stat-color);
  content: "";
}

.ops-stat > span {
  color: #77736c;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-stat > div {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.ops-stat strong {
  color: #292622;
  font-size: 25px;
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.04em;
}

.ops-stat small {
  color: #aaa69f;
  font-size: 12px;
}

.ops-stat--neutral {
  --stat-color: #8a9ab0;
}

.ops-stat--green {
  --stat-color: #52732e;
}

.ops-stat--violet {
  --stat-color: #70578e;
}

.ops-stat--amber {
  --stat-color: #c77813;
}

.ops-panel {
  animation: ops-panel-in 540ms 170ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-toolbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.ops-tabs {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border-radius: 10px;
  background: #eff1ed;
}

.ops-tab {
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #716e67;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: color 170ms ease, background 170ms ease, box-shadow 170ms ease, transform 170ms ease;
}

.ops-tab em {
  min-width: 19px;
  height: 19px;
  display: inline-grid;
  place-items: center;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(87, 83, 75, 0.08);
  color: #8a867f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.ops-tab:hover {
  color: #34312d;
}

.ops-tab.is-active {
  background: #fff;
  color: #2f4024;
  box-shadow: 0 2px 8px rgba(45, 51, 40, 0.1), inset 0 0 0 1px rgba(62, 82, 45, 0.08);
  transform: translateY(-1px);
}

.ops-tab.is-active em {
  background: #e7eee0;
  color: #47632f;
}

.ops-filter-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-search,
.ops-select {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #d6d3cc;
  border-radius: 9px;
  background: #fff;
  color: #858078;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-search {
  width: 265px;
  padding-left: 12px;
}

.ops-select {
  width: 145px;
  padding-left: 11px;
}

.ops-search:focus-within,
.ops-select:focus-within {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-search > svg,
.ops-select > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.ops-search input,
.ops-select select {
  width: 100%;
  height: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #403d38;
  font-size: 12px;
}

.ops-search input {
  padding: 0 34px 0 10px;
}

.ops-select select {
  padding: 0 9px;
}

.ops-search input::placeholder {
  color: #a39f97;
}

.ops-search > button {
  position: absolute;
  right: 7px;
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  background: #f0f1ed;
  color: #77736c;
  cursor: pointer;
}

.ops-check {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #625f59;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.ops-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.ops-check > span {
  width: 34px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #d8d9d4;
  transition: background 180ms ease;
}

.ops-check > span i {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(25, 27, 23, 0.18);
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-check input:checked + span {
  background: #547535;
}

.ops-check input:checked + span i {
  transform: translateX(14px);
}

.ops-check strong {
  font-weight: 700;
}

.ops-result-meta {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--ops-line-soft);
  background: #fcfcfa;
}

.ops-result-meta > div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7f7b74;
  font-size: 12px;
}

.ops-result-meta > div strong {
  color: var(--ops-orange);
  font-size: 14px;
  font-weight: 700;
}

.ops-reset-button {
  padding: 6px 8px;
  border: 0;
  background: transparent;
  color: #6e6a63;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease;
}

.ops-reset-button:hover {
  background: #eef0ea;
  color: #40572f;
}

.ops-table-wrap {
  width: 100%;
  overflow: hidden;
}

.ops-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.ops-table thead {
  background: #f5f6f2;
}

.ops-table th {
  height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #ddd9d2;
  color: #6f6b64;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.ops-table th:first-child,
.ops-table td:first-child {
  padding-left: 18px;
}

.ops-table th:last-child,
.ops-table td:last-child {
  padding-right: 18px;
}

.ops-table th.is-number,
.ops-table td.is-number {
  text-align: right;
}

.ops-table td {
  height: 66px;
  padding: 0 12px;
  border-bottom: 1px solid #ece9e3;
  color: #4f4b45;
  font-size: 13px;
  vertical-align: middle;
}

.ops-table tbody:last-child tr:last-child td,
.ops-table tbody > tr:last-child td {
  border-bottom: 0;
}

.ops-row {
  animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 170ms ease, box-shadow 170ms ease;
}

.ops-row:hover {
  background: #fafbf8;
  box-shadow: inset 3px 0 0 #688649;
}

.ops-identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.ops-identity > div {
  min-width: 0;
}

.ops-identity > div > strong {
  display: block;
  overflow: hidden;
  color: #302d29;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-identity > div > p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #8f8b84;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-mark,
.ops-avatar {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.ops-mark--survey {
  border: 1px solid #d7e4cd;
  background: #eef4e9;
  color: #527136;
}

.ops-mark--harness {
  border: 1px solid #ded7e7;
  background: #f2eff6;
  color: #67547e;
}

.ops-avatar {
  border-radius: 12px;
  background: linear-gradient(145deg, #3d552a, #2d411f);
  color: #fff;
  box-shadow: 0 5px 12px rgba(48, 73, 31, 0.16);
  font-size: 12px;
}

.ops-row:hover .ops-mark,
.ops-row:hover .ops-avatar {
  box-shadow: 0 6px 13px rgba(49, 57, 43, 0.11);
  transform: translateY(-1px);
}

.ops-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid var(--status-line);
  border-radius: 999px;
  background: var(--status-bg);
  color: var(--status-color);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-status i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.status-live {
  --status-bg: #eef5e8;
  --status-color: #4c6e2f;
  --status-line: #d2e1c5;
}

.status-draft {
  --status-bg: #f1f1ee;
  --status-color: #69655e;
  --status-line: #ddd9d2;
}

.status-experiment {
  --status-bg: #f3eef8;
  --status-color: #6c5189;
  --status-line: #ded1e9;
}

.ops-version {
  display: inline-flex;
  padding: 5px 8px;
  border: 1px solid #edd7c6;
  border-radius: 7px;
  background: #fff5ed;
  color: #a4501d;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
}

.ops-number {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.ops-number--strong {
  color: #383530;
  font-weight: 700;
}

.ops-owner {
  color: #58544e;
  font-size: 12px;
  font-weight: 700;
}

.ops-date {
  color: #7f7b74;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

.ops-row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #625e58;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.ops-row-action svg {
  width: 14px;
  height: 14px;
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-row-action.is-open svg {
  transform: rotate(180deg);
}

.ops-row-action:hover {
  background: #eef1e9;
  color: #40582f;
}

.ops-row-action--button {
  border: 1px solid #d7d4cd;
  background: #fff;
}

.ops-history-row td {
  height: auto;
  padding: 14px 18px 18px !important;
  background: #f7f8f4;
}

.ops-inline-history {
  overflow: hidden;
  border: 1px solid #dcd9d2;
  border-radius: 10px;
  background: #fff;
  animation: ops-history-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.survey-history-grid {
  display: grid;
  grid-template-columns: 90px 120px 110px minmax(220px, 1fr) 70px;
  align-items: center;
  gap: 10px;
}

.ops-inline-history__head {
  min-height: 35px;
  padding: 0 14px;
  border-bottom: 1px solid #e5e2dc;
  background: #f6f6f3;
  color: #817d76;
  font-size: 12px;
  font-weight: 700;
}

.ops-inline-history__item {
  min-height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #eeece7;
  color: #615d56;
  font-size: 12px;
  animation: ops-row-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-inline-history__item:last-child {
  border-bottom: 0;
}

.ops-inline-history__item strong {
  color: #5c5851;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.ops-inline-history__item strong.is-active {
  color: var(--ops-orange);
}

.ops-inline-history__item p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-inline-history__item .is-number {
  text-align: right;
}

.ops-progress {
  display: flex;
  align-items: center;
  gap: 9px;
}

.ops-progress > div,
.ops-progress-track {
  height: 7px;
  flex: 1;
  overflow: hidden;
  border-radius: 999px;
  background: #e9ebe6;
}

.ops-progress i,
.ops-progress-track i {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: #658747;
  transform-origin: left center;
  animation: ops-progress-in 760ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-progress i.is-warning,
.ops-progress-track i.is-warning {
  background: #bf781a;
}

.ops-progress i.is-complete,
.ops-progress-track i.is-complete {
  background: #4e7950;
}

.ops-progress strong {
  width: 43px;
  flex: 0 0 auto;
  color: #4f4b45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.ops-delta {
  color: #477442;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
}

.ops-delta.is-negative {
  color: #b24b38;
}

.ops-field {
  display: grid;
  gap: 4px;
}

.ops-field strong {
  color: #4b4741;
  font-size: 12px;
  font-weight: 700;
}

.ops-field span {
  color: #918d85;
  font-size: 12px;
}

.ops-rating {
  color: #4b6537;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 700;
}

.ops-due {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 700;
}

.ops-due.is-warning {
  color: #b06410;
}

.ops-toggle {
  position: relative;
  width: 40px;
  height: 23px;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: #d4d6d0;
  cursor: pointer;
  transition: background 180ms ease, box-shadow 180ms ease;
}

.ops-toggle > span {
  width: 17px;
  height: 17px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(28, 31, 25, 0.22);
  transition: transform 230ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-toggle.is-active {
  background: #547536;
  box-shadow: 0 0 0 3px rgba(84, 117, 54, 0.1);
}

.ops-toggle.is-active > span {
  transform: translateX(17px);
}

.ops-mobile-list {
  display: none;
}

.ops-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  animation: ops-fade-up 380ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-empty strong {
  font-size: 14px;
}

.ops-empty p {
  margin: 7px 0 0;
  color: #827e77;
  font-size: 12px;
}

.ops-empty button {
  margin-top: 14px;
  padding: 8px 12px;
  border: 1px solid #d6d3cc;
  background: #fff;
  color: #425a31;
  cursor: pointer;
}

.ops-footer {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid var(--ops-line);
  background: #fbfbf9;
  color: #807c75;
  font-size: 12px;
}

.ops-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(27, 28, 24, 0.52);
  backdrop-filter: blur(5px);
  animation: ops-backdrop-in 220ms ease-out both;
}

.ops-modal {
  width: min(100%, 530px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(22, 24, 20, 0.28);
  animation: ops-modal-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-modal--wide {
  width: min(100%, 760px);
}

.ops-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 19px;
  border-bottom: 1px solid var(--ops-line);
  background: linear-gradient(120deg, #fff 0%, #f7f9f4 100%);
}

.ops-modal__header p {
  margin: 0;
  color: var(--ops-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.ops-modal__header h2 {
  margin: 6px 0 0;
  color: #282521;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.ops-modal__header span {
  display: block;
  margin-top: 6px;
  color: #7f7b74;
  font-size: 12px;
}

.ops-modal__header > button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  background: #eef1ea;
  color: #66625b;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;
}

.ops-modal__header > button:hover {
  background: #e3e8dc;
  color: #354828;
  transform: rotate(5deg);
}

.ops-modal__body {
  display: grid;
  gap: 17px;
  padding: 22px 24px;
}

.ops-modal__body--scroll {
  max-height: 62vh;
  overflow-y: auto;
}

.ops-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.ops-form-field {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.ops-form-field > span {
  color: #4e4a44;
  font-size: 12px;
  font-weight: 700;
}

.ops-form-field input,
.ops-form-field select,
.ops-form-field textarea {
  width: 100%;
  padding: 0 13px;
  border: 1px solid #d5d2cb;
  border-radius: 9px;
  outline: 0;
  background: #fff;
  color: #37342f;
  font-size: 13px;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-form-field input,
.ops-form-field select {
  height: 43px;
}

.ops-form-field textarea {
  min-height: 90px;
  padding-top: 11px;
  padding-bottom: 11px;
  resize: vertical;
}

.ops-form-field input:focus,
.ops-form-field select:focus,
.ops-form-field textarea:focus {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-form-field input::placeholder,
.ops-form-field textarea::placeholder {
  color: #aaa69e;
}

.ops-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--ops-line);
  background: #f8f8f5;
}

.ops-modal__footer button {
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.ops-modal-cancel {
  border: 1px solid #d5d2cb;
  background: #fff;
  color: #625e58;
}

.ops-modal-submit {
  border: 1px solid var(--ops-olive);
  background: var(--ops-olive);
  color: #fff;
}

.ops-modal-submit:hover {
  background: #3d592a;
  box-shadow: 0 7px 15px rgba(48, 73, 31, 0.17);
  transform: translateY(-1px);
}

.ops-timeline {
  position: relative;
  display: grid;
  gap: 0;
  padding-left: 25px;
}

.ops-timeline::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 5px;
  width: 1px;
  background: #d9d6cf;
  content: "";
}

.ops-timeline__item {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  padding: 0 0 22px;
  animation: ops-row-in 400ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-timeline__item:last-child {
  padding-bottom: 0;
}

.ops-timeline__item > i {
  position: absolute;
  top: 5px;
  left: -24px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #b9b6af;
  box-shadow: 0 0 0 4px #fff;
}

.ops-timeline__item > i.is-active {
  background: var(--ops-orange);
}

.ops-timeline__content > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-timeline__content > div strong {
  color: #3d3934;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 700;
}

.ops-timeline__content > div span {
  padding: 3px 7px;
  border-radius: 999px;
  background: #fff0e5;
  color: var(--ops-orange);
  font-size: 12px;
  font-weight: 700;
}

.ops-timeline__content h3 {
  margin: 7px 0 0;
  color: #45413b;
  font-size: 13px;
  font-weight: 700;
}

.ops-timeline__content p {
  margin: 6px 0 0;
  color: #8b877f;
  font-size: 12px;
}

.ops-timeline__metrics {
  display: flex;
  gap: 8px;
}

.ops-timeline__metrics > span {
  min-width: 74px;
  display: grid;
  gap: 4px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #f4f6f1;
  text-align: center;
}

.ops-timeline__metrics small {
  color: #818079;
  font-size: 12px;
}

.ops-timeline__metrics strong {
  color: #456332;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

@media (max-width: 1279px) {
  .ops-table-wrap {
    display: none;
  }
  .ops-mobile-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 14px;
    background: #f7f7f4;
  }
  .ops-mobile-card {
    min-width: 0;
    padding: 15px;
    border: 1px solid #ddd9d2;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(42, 40, 35, 0.035);
    animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: border-color 170ms ease, box-shadow 170ms ease, transform 170ms ease;
  }
  .ops-mobile-card:hover {
    border-color: #b8c3ad;
    box-shadow: 0 8px 19px rgba(45, 57, 36, 0.08);
    transform: translateY(-1px);
  }
  .ops-mobile-card__top,
  .expert-mobile-head,
  .expert-mobile-field,
  .ops-mobile-progress > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-card__top {
    align-items: flex-start;
  }
  .ops-mobile-card__title {
    margin-top: 13px;
  }
  .ops-mobile-card__title > strong {
    display: block;
    overflow: hidden;
    color: #302d29;
    font-size: 15px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-card__title > p {
    margin: 5px 0 0;
    color: #8f8b84;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
  }
  .ops-mobile-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    border-top: 1px solid #ebe8e2;
    border-left: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics > div {
    min-width: 0;
    display: grid;
    gap: 5px;
    padding: 10px;
    border-right: 1px solid #ebe8e2;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics span,
  .expert-mobile-field span,
  .ops-mobile-progress span {
    color: #858179;
    font-size: 12px;
  }
  .ops-mobile-metrics strong,
  .expert-mobile-field strong {
    overflow: hidden;
    color: #44403a;
    font-size: 12px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-progress {
    display: grid;
    gap: 8px;
    margin-top: 14px;
  }
  .ops-mobile-progress strong {
    color: #4e4a44;
    font-size: 12px;
  }
  .ops-mobile-history-button {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    padding: 0 11px;
    border: 1px solid #d8d5ce;
    background: #fafaf8;
    color: #535e49;
    cursor: pointer;
  }
  .ops-mobile-history-button svg {
    width: 15px;
    height: 15px;
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
  }
  .ops-mobile-history-button svg.is-open {
    transform: rotate(180deg);
  }
  .ops-mobile-history {
    display: grid;
    gap: 0;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #dfdcd5;
    border-radius: 9px;
    animation: ops-history-in 340ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  .ops-mobile-history__item {
    padding: 10px 11px;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-history__item:last-child {
    border-bottom: 0;
  }
  .ops-mobile-history__item > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-history__item strong {
    color: #55514b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
  }
  .ops-mobile-history__item strong.is-active {
    color: var(--ops-orange);
  }
  .ops-mobile-history__item span,
  .ops-mobile-history__item p {
    color: #89857d;
    font-size: 12px;
  }
  .ops-mobile-history__item p {
    margin: 6px 0 0;
  }
  .expert-mobile-head .ops-identity {
    min-width: 0;
  }
  .expert-mobile-field {
    margin-top: 14px;
    padding: 10px 11px;
    border-radius: 8px;
    background: #f4f6f1;
  }
}
@media (max-width: 960px) {
  .ops-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .ops-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }
  .ops-tabs::-webkit-scrollbar {
    display: none;
  }
  .ops-search {
    width: 100%;
  }
  .ops-filter-group {
    width: 100%;
  }
  .ops-filter-group .ops-search {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .ops-shell {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ops-header__inner {
    height: auto;
  }
  .ops-heading {
    flex: 1;
  }
  .ops-eyebrow {
    font-size: 12px;
  }
  .ops-heading > p {
    max-width: 245px;
    font-size: 12px;
  }
  .ops-header-status {
    display: none;
  }
  .ops-primary-button {
    width: 41px;
    padding: 0;
  }
  .ops-primary-button > span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .ops-content {
    gap: 14px;
    padding-top: 14px;
    padding-bottom: 18px;
  }
  .ops-summary,
  .ops-panel {
    border-radius: 13px;
  }
  .ops-summary {
    display: block;
  }
  .ops-summary__intro {
    min-height: 68px;
    padding: 0 14px;
    border-right: 0;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ops-stat {
    min-height: 68px;
    padding: 0 14px;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-stat:nth-child(even) {
    border-right: 0;
  }
  .ops-stat:nth-child(3),
  .ops-stat:nth-child(4) {
    border-bottom: 0;
  }
  .ops-stat strong {
    font-size: 21px;
  }
  .ops-stat > span {
    font-size: 12px;
  }
  .ops-toolbar {
    padding: 12px;
  }
  .ops-tabs {
    width: 100%;
  }
  .ops-tab {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    font-size: 12px;
  }
  .ops-tabs--wide .ops-tab em {
    display: none;
  }
  .ops-toolbar--experts .ops-filter-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 128px;
  }
  .ops-select {
    width: 100%;
  }
  .ops-check {
    align-self: flex-start;
  }
  .ops-result-meta {
    min-height: 48px;
    padding: 6px 12px;
  }
  .ops-mobile-list {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .ops-mobile-card {
    padding: 14px;
  }
  .ops-footer {
    padding: 0 12px;
  }
  .ops-footer span:last-child {
    display: none;
  }
  .ops-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .ops-modal,
  .ops-modal--wide {
    width: 100%;
    max-height: 92vh;
    overflow-y: auto;
    border-radius: 19px 19px 0 0;
    animation-name: ops-sheet-in;
  }
  .ops-modal__header,
  .ops-modal__body,
  .ops-modal__footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .ops-form-grid {
    grid-template-columns: 1fr;
  }
  .ops-timeline__item {
    grid-template-columns: 1fr;
  }
  .ops-timeline__metrics {
    justify-content: flex-start;
  }
}
@media (max-width: 420px) {
  .ops-heading > p {
    max-width: 255px;
  }
  .ops-toolbar--experts .ops-filter-group {
    grid-template-columns: 1fr;
  }
}
@keyframes ops-fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px);
    box-shadow: 0 2px 5px rgba(42, 40, 35, 0);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-stat-in {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ops-row-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-progress-in {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes ops-history-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-live {
  0% {
    opacity: 0.9;
    transform: scale(0.7);
  }
  65%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@keyframes ops-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ops-modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes ops-sheet-in {
  from {
    opacity: 0;
    transform: translateY(35px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ops-heading,
  .ops-header__actions,
  .ops-summary,
  .ops-panel,
  .ops-stat,
  .ops-row,
  .ops-mobile-card,
  .ops-empty,
  .ops-inline-history,
  .ops-inline-history__item,
  .ops-mobile-history,
  .ops-progress i,
  .ops-progress-track i,
  .ops-header-status i::after,
  .ops-modal-backdrop,
  .ops-modal,
  .ops-timeline__item {
    animation: none !important;
  }
  .ops-primary-button,
  .ops-primary-button svg,
  .ops-row,
  .ops-mobile-card,
  .ops-mark,
  .ops-avatar,
  .ops-toggle,
  .ops-toggle > span,
  .ops-row-action svg,
  .ops-mobile-history-button svg {
    transition: none !important;
  }
}
/* Survey document workspace — reference 01 */
.ops-page--survey-detail {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--ops-canvas);
}

.ops-page--survey-detail .survey-control-content--detail {
  width: 100%;
  max-width: none;
  height: auto;
  min-height: 0;
  margin: 0;
}

.survey-detail {
  height: 100%;
  min-height: 0;
  display: grid;
  /* The header is outside this panel; its only row is the workspace. */
  grid-template-rows: minmax(0, 1fr);
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.survey-workspace-header {
  display: grid;
  grid-template-columns: 168px minmax(0, 1fr) auto;
  align-items: stretch;
  min-width: 0;
  background: #fff;
  box-shadow: 0 1px 0 #dde1e5;
  position: relative;
  z-index: 4;
}

/* Keep the back action inside the workspace bar instead of rendering it as a
   second card when the shared detail-bar rules are applied. */
.ops-page--survey-detail .survey-workspace-header.reviewops-unified-detail-bar {
  min-height: 86px;
  padding: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid #dde1e5 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

.survey-workspace-header__back {
  display: flex;
  height: 100%;
  align-items: center;
  gap: 12px;
  padding: 0 22px;
  border: 0;
  border-right: 1px solid #e5e8e2;
  background: transparent;
  color: #25292d;
  cursor: pointer;
  white-space: nowrap;
}

.survey-workspace-header__back i {
  margin-top: 0;
  color: #4d5359;
  font-size: 13px;
}

.survey-workspace-header__back:hover {
  color: #d94f29;
  background: #f7f9f6;
}

.survey-workspace-header__back:focus-visible {
  outline: 2px solid rgba(217, 79, 41, 0.5);
  outline-offset: -3px;
}

.survey-workspace-header__title {
  min-width: 0;
  padding: 13px 28px 12px;
}

.survey-workspace-header__title h2 {
  overflow: hidden;
  margin: 0;
  color: #202326;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.025em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-workspace-header__title dl {
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 9px 0 0;
}

.survey-workspace-header__title dl div {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.survey-workspace-header__title dt {
  color: #898e94;
  font-size: 12px;
  font-weight: 700;
}

.survey-workspace-header__title dd {
  margin: 0;
  color: #2f3337;
  font-size: 12px;
  font-weight: 700;
}

.survey-workspace-header__actions {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 18px;
  white-space: nowrap;
}

.survey-workspace-header__actions > strong {
  color: #e3542d;
  font-size: 12px;
  font-weight: 700;
}

.survey-workspace-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #4f7b38;
  font-size: 12px;
  font-weight: 700;
}

.survey-workspace-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.survey-workspace-header__actions .survey-create-button {
  min-height: 42px;
  margin: 0;
  padding: 0 16px;
  box-shadow: none;
}

.survey-workspace {
  display: grid;
  grid-template-columns: 168px minmax(520px, 1fr) 248px;
  gap: 1px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #dfe3e0;
  transition: grid-template-columns 180ms ease;
}

.survey-workspace.is-outline-collapsed {
  grid-template-columns: 48px minmax(520px, 1fr) 248px;
}

.survey-outline,
.survey-inspector,
.survey-document {
  min-width: 0;
  min-height: 0;
}

.survey-outline {
  overflow: hidden;
  background: #f7f8f8;
  box-shadow: none;
}

.survey-outline__header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px 0 16px;
  background: #f7f8f8;
  color: #33383d;
  box-shadow: inset 0 -1px 0 #dfe3e0;
}

.survey-outline__header strong {
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.survey-outline__header button {
  width: 28px;
  height: 28px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border: 0;
  background: transparent;
  color: #555b61;
  cursor: pointer;
}

.survey-outline__header button:hover {
  background: #e8eaec;
}

.survey-outline__pages {
  height: calc(100% - 48px);
  display: grid;
  align-content: start;
  gap: 15px;
  overflow-y: auto;
  padding: 14px 18px 22px;
  scrollbar-width: thin;
}

.survey-thumbnail {
  min-width: 0;
  text-align: center;
}

.survey-thumbnail__preview {
  width: 100%;
  aspect-ratio: 210/297;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 0 1px #d8dce0, 0 2px 7px rgba(25, 30, 35, 0.07);
}

.survey-thumbnail.is-active .survey-thumbnail__preview {
  box-shadow: 0 0 0 2px #ef5a30, 0 4px 10px rgba(213, 76, 36, 0.13);
}

.survey-thumbnail__preview img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  pointer-events: none;
}

.survey-thumbnail__preview button {
  position: absolute;
  inset: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.survey-thumbnail strong,
.survey-thumbnail span {
  display: block;
}

.survey-thumbnail strong {
  margin-top: 8px;
  color: #31353a;
  font-size: 12px;
  font-weight: 700;
}

.survey-thumbnail span {
  margin-top: 2px;
  overflow: hidden;
  color: #686e74;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-workspace.is-outline-collapsed .survey-outline__header {
  justify-content: center;
  padding: 0;
}

.survey-workspace.is-outline-collapsed .survey-outline__header strong,
.survey-workspace.is-outline-collapsed .survey-outline__pages {
  display: none;
}

.survey-document {
  display: grid;
  grid-template-rows: 48px minmax(0, 1fr);
  overflow: hidden;
  background: #e9ecef;
}

.survey-document-toolbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  background: #f9fafb;
  color: #363b40;
  box-shadow: inset 0 -1px 0 #dfe3e0;
  position: relative;
  z-index: 2;
}

.survey-document-toolbar__pages,
.survey-document-toolbar__zoom,
.survey-document-toolbar__export {
  display: flex;
  align-items: center;
}

.survey-document-toolbar__pages {
  justify-self: start;
  gap: 5px;
}

.survey-document-toolbar__pages > span {
  margin-right: 10px;
  color: #757b81;
  font-size: 12px;
  font-weight: 700;
}

.survey-document-toolbar__pages strong {
  min-width: 30px;
  height: 26px;
  display: grid;
  place-items: center;
  border: 1px solid #d6dade;
  border-radius: 4px;
  background: #fff;
  font-size: 12px;
}

.survey-document-toolbar__pages em {
  margin-right: 2px;
  color: #60666c;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.survey-document-toolbar__zoom {
  justify-self: center;
  gap: 5px;
}

.survey-document-toolbar__zoom > strong {
  min-width: 54px;
  color: #353a3f;
  font-size: 12px;
  text-align: center;
}

.survey-document-toolbar__export {
  justify-self: end;
  gap: 5px;
}

.survey-document-toolbar button,
.survey-document-toolbar a {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #3e444a;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
}

.survey-document-toolbar button:hover,
.survey-document-toolbar a:hover {
  background: #e9ecef;
}

.survey-document-toolbar button:disabled {
  opacity: 0.28;
  cursor: default;
}

.survey-document-toolbar__divider {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #d9dde0;
}

.survey-document-viewer {
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding: 0;
  background: #292b2d;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.survey-document-viewer:fullscreen {
  padding: 0;
  background: #202326;
}

/* Keep the focus ring inside the clipped PDF viewport and thumbnail. */
.ops-page--survey-detail .survey-document-viewer:focus-visible,
.ops-page--survey-detail .survey-thumbnail__preview button:focus-visible {
  outline-offset: -4px;
}

.survey-document-pages {
  min-width: 60%;
  display: grid;
  gap: 18px;
  margin: 0 auto;
  padding: 18px;
  transition: width 140ms ease;
}

.survey-document-page {
  width: 100%;
  aspect-ratio: 210/297;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.24);
}

.survey-document-page img {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
  background: #fff;
  object-fit: contain;
}

.survey-document-page.is-current {
  outline: 1px solid rgba(255, 255, 255, 0.26);
  outline-offset: 2px;
}

.survey-inspector {
  display: grid;
  align-content: start;
  gap: 1px;
  overflow-y: auto;
  background: #dfe3e0;
  box-shadow: none;
  scrollbar-width: thin;
}

.survey-inspector__section {
  padding: 19px 18px;
  background: #fff;
  box-shadow: none;
}

.survey-inspector__section h3 {
  margin: 0 0 15px;
  color: #30353a;
  font-size: 12px;
  font-weight: 700;
}

.survey-inspector__summary {
  display: grid;
  gap: 13px;
  margin: 0;
}

.survey-inspector__summary div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.survey-inspector__summary dt {
  color: #878d93;
  font-size: 12px;
  font-weight: 700;
}

.survey-inspector__summary dd {
  overflow: hidden;
  margin: 0;
  color: #34393e;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-inspector__summary dd.is-orange {
  color: #e3542d;
}

.survey-inspector__summary dd.is-live {
  color: #54833c;
}

.survey-inspector__buttons {
  display: grid;
  gap: 8px;
}

.survey-inspector__buttons button,
.survey-inspector__buttons a,
.survey-inspector__danger button {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid #d4d9dd;
  border-radius: 5px;
  background: #fff;
  color: #3c4247;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.survey-inspector__buttons button:hover,
.survey-inspector__buttons a:hover {
  border-color: #8e989f;
  background: #f4f5f5;
}

.survey-inspector-history {
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  background: #f0f2f3;
}

.survey-inspector-history article {
  display: grid;
  gap: 3px;
}

.survey-inspector-history strong {
  color: #d9522d;
  font-size: 12px;
}

.survey-inspector-history span,
.survey-inspector-history p {
  margin: 0;
  color: #777d82;
  font-size: 12px;
  line-height: 1.5;
}

.survey-inspector__danger {
  background: #fff;
  box-shadow: none;
}

.survey-inspector__danger button {
  width: 100%;
  border-color: #efb6a8;
  color: #d84e2b;
}

.survey-inspector__danger button:hover {
  background: #fff5f2;
}

@media (max-width: 1180px) {
  .survey-workspace-header {
    grid-template-columns: 145px minmax(0, 1fr) auto;
  }
  .survey-workspace-header__title dl {
    gap: 16px;
  }
  .survey-workspace-header__actions {
    gap: 9px;
    padding-inline: 12px;
  }
  .survey-workspace {
    grid-template-columns: 132px minmax(480px, 1fr) 220px;
  }
  .survey-outline__pages {
    padding-inline: 14px;
  }
}
@media (max-width: 940px) {
  .survey-workspace-header {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .survey-workspace-header__back {
    padding: 22px 18px;
  }
  .survey-workspace-header__back span,
  .survey-workspace-header__title dl,
  .survey-workspace-header__actions > strong,
  .survey-workspace-status {
    display: none;
  }
  .survey-workspace-header__actions {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
  }
  .survey-workspace {
    grid-template-columns: 116px minmax(0, 1fr);
    min-height: 820px;
  }
  .survey-inspector {
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1px;
    overflow: visible;
    background: #dfe3e0;
    box-shadow: none;
  }
}
@media (max-width: 640px) {
  .survey-workspace-header__title {
    padding-inline: 8px;
  }
  .survey-workspace-header__title h2 {
    font-size: 14px;
  }
  .survey-workspace-header__actions .survey-create-button {
    width: 40px;
    padding: 0;
  }
  .survey-workspace-header__actions .survey-create-button span {
    display: none;
  }
  .survey-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .survey-outline {
    display: none;
  }
  .survey-document-toolbar {
    grid-template-columns: auto 1fr;
    padding-inline: 8px;
  }
  .survey-document-toolbar__zoom {
    justify-self: end;
  }
  .survey-document-toolbar__export {
    display: none;
  }
  .survey-document-viewer {
    min-height: 720px;
    padding: 6px;
  }
  .survey-inspector {
    grid-template-columns: 1fr;
  }
}
:host {
  display: block;
  height: 100%;
}

.survey-table th:nth-child(1) {
  width: 28%;
}

.survey-table th:nth-child(2) {
  width: 10%;
}

.survey-table th:nth-child(3) {
  width: 10%;
}

.survey-table th:nth-child(4) {
  width: 7%;
}

.survey-table th:nth-child(5) {
  width: 11%;
}

.survey-table th:nth-child(6) {
  width: 9%;
}

.survey-table th:nth-child(7) {
  width: 12%;
}

.survey-table th:nth-child(8) {
  width: 13%;
}

.survey-row-link {
  cursor: pointer;
}

.survey-row-link:focus-visible {
  position: relative;
  z-index: 1;
  outline: 2px solid var(--ops-green);
  outline-offset: -2px;
}

.survey-mobile-open {
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding: 0 13px;
  border: 1px solid #cfd9c5;
  border-radius: 9px;
  background: #f4f8ef;
  color: var(--ops-olive);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.survey-mobile-open svg {
  width: 14px;
  height: 14px;
}

.survey-detail {
  overflow: hidden;
  border: 1px solid #d9d6cf;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 13px 32px rgba(42, 40, 35, 0.06), 0 2px 5px rgba(42, 40, 35, 0.03);
  animation: ops-panel-in 440ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.survey-detail__header {
  padding: 24px;
  border-bottom: 1px solid var(--ops-line-soft);
  background: linear-gradient(120deg, #fff 0%, #f7f9f3 100%);
}

.survey-detail__back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #656158;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.survey-detail__back svg {
  width: 15px;
  height: 15px;
}

.survey-detail__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-top: 20px;
}

.survey-detail__heading > div:first-child {
  min-width: 0;
}

.survey-detail__heading p {
  margin: 0;
  color: var(--ops-orange);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.survey-detail__heading h2 {
  margin: 7px 0 0;
  color: var(--ops-ink);
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.035em;
}

.survey-detail__heading > div:first-child > span {
  display: block;
  max-width: 840px;
  margin-top: 9px;
  color: var(--ops-muted);
  font-size: 12px;
  line-height: 1.65;
}

.survey-detail__badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.survey-detail__badges em {
  padding: 7px 10px;
  border: 1px solid #e9cfbb;
  border-radius: 8px;
  background: #fff7ef;
  color: var(--ops-orange);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.survey-detail__meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  border-bottom: 1px solid var(--ops-line-soft);
}

.survey-detail__meta > div {
  min-width: 0;
  padding: 16px 22px;
  border-right: 1px solid var(--ops-line-soft);
}

.survey-detail__meta > div:last-child {
  border-right: 0;
}

.survey-detail__meta dt {
  color: #969187;
  font-size: 12px;
  font-weight: 700;
}

.survey-detail__meta dd {
  margin: 5px 0 0;
  color: var(--ops-ink);
  font-size: 13px;
  font-weight: 700;
}

.survey-pdf {
  background: #262724;
}

.survey-pdf__toolbar {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 11px 16px 11px 20px;
  border-bottom: 1px solid #464842;
  background: #32332f;
  color: #fff;
}

.survey-pdf__toolbar strong,
.survey-pdf__toolbar span {
  display: block;
}

.survey-pdf__toolbar strong {
  font-size: 12px;
  font-weight: 700;
}

.survey-pdf__toolbar > div:first-child > span {
  margin-top: 4px;
  color: #bdbfb8;
  font-size: 12px;
}

.survey-pdf__actions {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
}

.survey-pdf__actions button,
.survey-pdf__actions a {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #62645d;
  border-radius: 8px;
  background: #41423d;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  transition: background 160ms ease, border-color 160ms ease;
}

.survey-pdf__actions button:hover,
.survey-pdf__actions a:hover {
  border-color: #85887f;
  background: #50514b;
}

.survey-pdf__actions svg {
  width: 14px;
  height: 14px;
}

.survey-pdf__viewer {
  width: 100%;
  height: min(1120px, 100vh - 175px);
  min-height: 720px;
  padding: 14px;
  background: #262724;
}

.survey-pdf__viewer:fullscreen {
  height: 100vh;
  padding: 0;
  background: #1e1f1c;
}

.survey-pdf__viewer object,
.survey-pdf__viewer iframe {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
  border-radius: 5px;
  background: #fff;
}

.survey-pdf__fallback {
  height: 100%;
  display: grid;
  place-content: center;
  gap: 12px;
  padding: 24px;
  background: #fff;
  color: var(--ops-ink);
  text-align: center;
}

.survey-pdf__fallback a {
  color: var(--ops-green);
  font-size: 12px;
  font-weight: 700;
}

.survey-detail__content {
  display: grid;
  gap: 16px;
  padding: 22px;
  background: #f7f8f4;
}

.survey-detail-section {
  overflow: hidden;
  border: 1px solid #dfdcd5;
  border-radius: 13px;
  background: #fff;
}

.survey-detail-section > header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.survey-detail-section > header > span {
  width: 28px;
  height: 28px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  background: #eef4e8;
  color: var(--ops-green);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.survey-detail-section h3,
.survey-detail-section h4,
.survey-detail-section p {
  margin: 0;
}

.survey-detail-section h3 {
  color: var(--ops-ink);
  font-size: 13px;
  font-weight: 700;
}

.survey-detail-section header p {
  margin-top: 4px;
  color: var(--ops-muted);
  font-size: 12px;
  line-height: 1.5;
}

.survey-option-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  padding: 16px 18px;
}

.survey-option-grid--four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.survey-option {
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid var(--ops-line-soft);
  border-radius: 9px;
  background: #fafaf8;
  color: #4f4b45;
  font-size: 12px;
  font-weight: 700;
}

.survey-option i {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  border: 1px solid #bdb8af;
  border-radius: 4px;
}

.survey-question-list {
  display: grid;
}

.survey-question {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 230px;
  align-items: center;
  gap: 24px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.survey-question:last-child {
  border-bottom: 0;
}

.survey-question__copy {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  min-width: 0;
}

.survey-question__copy em {
  width: 24px;
  height: 24px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 7px;
  background: #f1f0ec;
  color: #777269;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.survey-question h4,
.survey-narrative-list h4 {
  color: var(--ops-ink);
  font-size: 12px;
  font-weight: 700;
}

.survey-question p,
.survey-narrative-list p {
  margin-top: 5px;
  color: var(--ops-muted);
  font-size: 12px;
  line-height: 1.55;
}

.survey-scale {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
}

.survey-scale span {
  height: 34px;
  display: grid;
  place-items: center;
  border: 1px solid var(--ops-line);
  border-radius: 8px;
  background: #fafaf8;
  color: #716d65;
  font-size: 12px;
  font-weight: 700;
}

.survey-reason-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  padding: 16px 18px;
}

.survey-reason-grid article {
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--ops-line-soft);
  border-radius: 9px;
  background: #fafaf8;
}

.survey-reason-grid code {
  color: var(--ops-orange);
  font-size: 12px;
  font-weight: 700;
}

.survey-reason-grid p {
  margin-top: 5px;
  color: #56524b;
  font-size: 12px;
  line-height: 1.45;
}

.survey-narrative-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 16px 18px;
}

.survey-narrative-list article {
  min-width: 0;
  padding: 14px;
  border: 1px solid var(--ops-line-soft);
  border-radius: 10px;
  background: #fafaf8;
}

.survey-narrative-list article > div {
  min-height: 70px;
  margin-top: 12px;
  padding: 11px;
  border: 1px dashed #d5d1c8;
  border-radius: 8px;
  background: #fff;
  color: #aaa59c;
  font-size: 12px;
}

@media (max-width: 900px) {
  .survey-detail__heading {
    display: grid;
  }
  .survey-detail__badges {
    justify-content: flex-start;
  }
  .survey-detail__meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .survey-detail__meta > div:nth-child(2) {
    border-right: 0;
  }
  .survey-detail__meta > div:nth-child(-n+2) {
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .survey-option-grid,
  .survey-option-grid--four,
  .survey-reason-grid,
  .survey-narrative-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .survey-question {
    grid-template-columns: 1fr;
    gap: 13px;
  }
}
@media (max-width: 560px) {
  .survey-detail__header,
  .survey-detail__content {
    padding: 16px;
  }
  .survey-detail__heading h2 {
    font-size: 20px;
  }
  .survey-pdf__toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .survey-pdf__actions {
    width: 100%;
  }
  .survey-pdf__actions button,
  .survey-pdf__actions a {
    flex: 1 1 0;
  }
  .survey-pdf__viewer {
    min-height: 620px;
    padding: 8px;
  }
  .survey-option-grid,
  .survey-option-grid--four,
  .survey-reason-grid,
  .survey-narrative-list {
    grid-template-columns: 1fr;
  }
}
/* Selected survey control ledger */
.ops-page--survey {
  min-height: 100%;
  overflow-x: hidden;
  color: #202124;
  background: var(--ops-canvas);
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.ops-page--survey .ops-shell {
  width: min(100% - 40px, 1320px);
  padding-inline: 0;
}

.ops-page--survey .ops-heading h1 {
  margin-top: 9px;
}

.ops-page--survey .ops-heading > p {
  margin-top: 8px;
  color: #777880;
  font-size: 12px;
}

.survey-control-eyebrow {
  margin: 0;
  color: #d9552f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.survey-header-actions,
.survey-control-ledger__controls,
.survey-control-actions,
.survey-control-card__actions,
.survey-control-footer nav {
  display: flex;
  align-items: center;
}

.survey-header-actions {
  gap: 8px;
  flex: 0 0 auto;
}

.survey-create-button,
.survey-control-ledger button,
.survey-control-ledger input,
.survey-control-ledger select {
  box-shadow: none !important;
}

.survey-create-button {
  display: inline-flex;
  min-height: 46px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-left: 0;
  padding: 0 17px;
  color: #ffffff;
  background: #e2572f;
  cursor: pointer;
}

.survey-create-button:hover {
  background: #c94c29;
}

.survey-control-ledger {
  background: #ffffff;
}

.survey-control-ledger__header h2,
.survey-control-ledger__header p {
  margin: 0;
}

.survey-control-ledger__header h2 {
  color: #25262a;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.survey-control-ledger__header h2 em {
  margin-left: 7px;
  color: #85868d;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.survey-control-ledger__header p {
  margin-top: 6px;
  color: #85868d;
  font-size: 12px;
}

.survey-control-select,
.survey-control-search {
  position: relative;
  display: flex;
  height: 42px;
  align-items: center;
  color: #6c6d74;
  background: #ffffff;
  border: 1px solid #d8ddd3;
  border-radius: 7px;
  box-shadow: none;
  overflow: hidden;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.survey-control-select:focus-within,
.survey-control-search:focus-within {
  border-color: #78866c;
  box-shadow: 0 0 0 3px rgba(98, 117, 87, 0.11);
}

.survey-control-select select {
  width: 138px;
  height: 100%;
  padding: 0 32px 0 12px;
  color: #55565d;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-search > i {
  display: grid;
  width: 42px;
  height: 100%;
  flex: 0 0 42px;
  place-items: center;
  color: #777880;
  background: #f7f8f4;
  font-size: 12px;
}

.survey-control-search input {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0 36px 0 11px;
  color: #303136;
  box-shadow: none !important;
  font-size: 12px;
}

.survey-control-search button {
  position: absolute;
  inset-inline-end: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: #85868d;
  background: transparent;
  cursor: pointer;
}

.survey-control-ledger__meta {
  display: flex;
  min-height: 42px;
  align-items: center;
  gap: 12px;
  padding: 0 24px;
  color: #85868d;
  background: #fafafa;
  box-shadow: inset 0 -1px 0 #ececef;
  font-size: 12px;
}

.survey-control-ledger__meta strong {
  margin-right: 3px;
  color: #e2572f;
  font-size: 12px;
}

.survey-control-ledger__meta button {
  margin-left: auto;
  padding: 6px 9px;
  color: #66676e;
  background: #ffffff;
  cursor: pointer;
}

.survey-control-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.survey-control-table th {
  height: 48px;
  padding: 0 14px;
  color: #777880;
  background: #f6f6f7;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-table th:first-child,
.survey-control-table td:first-child {
  padding-left: 24px;
}

.survey-control-table th:last-child,
.survey-control-table td:last-child {
  padding-right: 24px;
}

.survey-control-table th:nth-child(1) {
  width: 27%;
}

.survey-control-table th:nth-child(2) {
  width: 10%;
}

.survey-control-table th:nth-child(3) {
  width: 9%;
}

.survey-control-table th:nth-child(4) {
  width: 8%;
}

.survey-control-table th:nth-child(5) {
  width: 10%;
}

.survey-control-table th:nth-child(6) {
  width: 9%;
}

.survey-control-table th:nth-child(7) {
  width: 10%;
}

.survey-control-table th:nth-child(8) {
  width: 17%;
}

.survey-control-row {
  min-height: 94px;
  background: #ffffff;
  box-shadow: inset 0 -1px 0 #ececef;
  cursor: pointer;
  animation: survey-row-in 0.28s ease both;
  transition: background-color 0.16s ease;
}

.survey-control-row:hover {
  background: #fafafa;
}

.survey-control-row:focus-visible {
  position: relative;
  z-index: 1;
  outline: 2px solid #e2572f;
  outline-offset: -2px;
}

.survey-control-row td {
  height: 94px;
  padding: 14px;
  vertical-align: middle;
}

.survey-control-identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.survey-control-mark {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  place-items: center;
  color: #4f6b2b;
  background: #eef3e8;
  font-size: 16px;
}

.survey-control-identity > div {
  min-width: 0;
}

.survey-control-identity strong,
.survey-control-identity p {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-control-identity strong {
  display: block;
  color: #25262a;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-identity p {
  margin-top: 6px;
  color: #8a8b92;
  font-size: 12px;
}

.survey-control-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.survey-control-status i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.survey-control-status.status-live {
  color: #4e712f;
  background: #eff4e9;
}

.survey-control-status.status-draft {
  color: #66676e;
  background: #f0f0f1;
}

.survey-control-status.status-review {
  color: #b84d28;
  background: #fff0ea;
}

.survey-control-version {
  display: inline-flex;
  padding: 6px 8px;
  color: #d4552d;
  background: #fff3ed;
  box-shadow: inset 0 0 0 1px #f4c0ab;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.survey-control-number,
.survey-control-owner,
.survey-control-date {
  color: #4d4e54;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.survey-control-date {
  color: #777880;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 700;
}

.survey-control-actions {
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: minmax(118px, 1fr) 38px;
  justify-content: flex-end;
  gap: 8px;
}

.survey-control-next {
  display: grid;
  width: 100%;
  min-width: 0;
  min-height: 38px;
  align-items: center;
  grid-template-columns: 16px minmax(0, 1fr) 10px;
  gap: 7px;
  padding: 0 12px;
  box-sizing: border-box;
  color: #ffffff;
  background: #343b34;
  border-radius: 7px;
  box-shadow: none !important;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: background-color 0.16s ease, transform 0.16s ease;
}

.survey-control-next i:first-child,
.survey-control-next i:last-child {
  width: 100%;
  text-align: center;
}

.survey-control-next span {
  min-width: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
}

.survey-control-next i:last-child {
  font-size: 12px;
}

.survey-control-next:hover {
  color: #ffffff;
  background: #d9552f;
  box-shadow: none !important;
  transform: translateY(-1px);
}

.survey-control-more {
  display: grid;
  width: 38px;
  height: 38px;
  box-sizing: border-box;
  place-items: center;
  color: #777880;
  background: #ffffff;
  border: 1px solid #d8ddd3;
  border-radius: 7px;
  cursor: pointer;
  transition: color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease;
}

.survey-control-more:hover,
.survey-control-more.is-open {
  color: #d9552f;
  border-color: #e5a18b;
  background: #fff4ef;
}

.survey-control-history td {
  padding: 16px 24px 20px;
  background: #f7f7f8;
  box-shadow: inset 0 -1px 0 #dedee1;
}

.survey-control-history .ops-inline-history {
  width: min(100%, 980px);
  margin: 0 auto;
  border: 1px solid #d8ddd3;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(44, 53, 44, 0.05);
}

.survey-history-summary {
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 20px;
  background: #ffffff;
  box-shadow: inset 0 -1px 0 #e6e9e2;
}

.survey-history-summary > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.survey-history-summary__icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  color: #5f7453;
  background: #eef3ea;
  border-radius: 7px;
}

.survey-history-summary strong,
.survey-history-summary p {
  margin: 0;
}

.survey-history-summary strong {
  display: block;
  color: #2c312d;
  font-size: 12px;
}

.survey-history-summary p {
  margin-top: 4px;
  color: #858b84;
  font-size: 12px;
}

.survey-history-summary__count {
  flex: 0 0 auto;
  padding: 6px 9px;
  color: #5f7453;
  background: #f1f4ee;
  border-radius: 999px;
  font-size: 12px;
}

.survey-control-history .survey-history-grid {
  grid-template-columns: 92px 116px 100px minmax(260px, 1fr) 86px;
  gap: 20px;
}

.survey-control-history .ops-inline-history__head {
  min-height: 42px;
  padding: 0 20px;
  border: 0;
  background: #f7f8f5;
  box-shadow: inset 0 -1px 0 #e6e9e2;
}

.survey-control-history .ops-inline-history__item {
  min-height: 52px;
  padding: 0 20px;
  border: 0;
  background: #ffffff;
  box-shadow: inset 0 -1px 0 #eef0eb;
  font-size: 12px;
}

.survey-control-history .ops-inline-history__item:last-child {
  box-shadow: none;
}

.survey-control-history .ops-inline-history__item p {
  line-height: 1.5;
}

.survey-control-history .ops-inline-history__head > :last-child,
.survey-control-history .ops-inline-history__item .is-number {
  text-align: right;
}

.survey-control-empty {
  display: grid;
  min-height: 260px;
  place-items: center;
  align-content: center;
  gap: 8px;
  padding: 30px;
  color: #777880;
  text-align: center;
}

.survey-control-empty > i {
  font-size: 24px;
}

.survey-control-empty strong {
  color: #38393e;
  font-size: 13px;
}

.survey-control-empty p {
  margin: 0;
  font-size: 12px;
}

.survey-control-empty button {
  margin-top: 5px;
  padding: 9px 12px;
  color: #ffffff;
  background: #303136;
  cursor: pointer;
}

.survey-control-footer {
  color: #777880;
}

.survey-control-footer > strong {
  color: #4f5057;
  font-size: 12px;
}

.survey-control-footer > span {
  justify-self: end;
}

.survey-control-footer > span i {
  margin-left: 8px;
}

.survey-control-footer nav {
  gap: 6px;
}

.survey-control-footer nav button {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  color: #66676e;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #d7d7db !important;
  cursor: pointer;
}

.survey-control-footer nav button.is-active {
  color: #e2572f;
  box-shadow: inset 0 0 0 1px #e2572f !important;
}

@keyframes survey-row-in {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1080px) {
  .survey-control-table th:nth-child(5),
  .survey-control-table td:nth-child(5),
  .survey-control-table th:nth-child(7),
  .survey-control-table td:nth-child(7) {
    display: none;
  }
  .survey-control-table th:nth-child(1) {
    width: 36%;
  }
  .survey-control-table th:nth-child(2) {
    width: 12%;
  }
  .survey-control-table th:nth-child(3) {
    width: 11%;
  }
  .survey-control-table th:nth-child(4) {
    width: 10%;
  }
  .survey-control-table th:nth-child(6) {
    width: 12%;
  }
  .survey-control-table th:nth-child(8) {
    width: 19%;
  }
}
@media (max-width: 820px) {
  .survey-header-actions {
    width: 100%;
  }
  .survey-create-button {
    margin-left: auto;
  }
  .survey-control-mobile {
    background: #ececef;
  }
  .survey-control-card {
    padding: 18px;
    background: #ffffff;
    animation: survey-row-in 0.28s ease both;
  }
  .survey-control-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
  }
  .survey-control-card h3,
  .survey-control-card p {
    margin: 0;
  }
  .survey-control-card h3 {
    margin-top: 9px;
    color: #25262a;
    font-size: 13px;
  }
  .survey-control-card p {
    margin-top: 5px;
    color: #85868d;
    font-size: 12px;
  }
  .survey-control-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1px;
    margin: 16px 0 0;
    background: #e8e8eb;
  }
  .survey-control-card dl div {
    padding: 11px;
    background: #f6f6f7;
  }
  .survey-control-card dt {
    color: #85868d;
    font-size: 12px;
    font-weight: 700;
  }
  .survey-control-card dd {
    margin: 5px 0 0;
    color: #4f5057;
    font-size: 12px;
    font-weight: 700;
  }
  .survey-control-card__actions {
    gap: 8px;
    margin-top: 14px;
  }
  .survey-control-card__actions button {
    min-height: 40px;
    padding: 0 14px;
    color: #ffffff;
    background: #303136;
    cursor: pointer;
  }
  .survey-control-card__actions button:first-child {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #e2572f;
  }
}
@media (max-width: 580px) {
  .ops-page--survey .ops-shell {
    width: min(100% - 24px, 1320px);
  }
  .survey-header-actions {
    flex-wrap: wrap;
  }
  .survey-utility {
    display: none;
  }
  .survey-create-button {
    width: 100%;
    margin-left: 0;
  }
  .survey-control-select,
  .survey-control-select select,
  .survey-control-search {
    width: 100%;
  }
  .survey-control-footer nav {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .survey-control-row,
  .survey-control-card {
    animation: none;
  }
}
/* -------------------------------------------------------------------------- */
/* Premium survey management workspace — authoritative list styles            */
/* -------------------------------------------------------------------------- */
.ops-page--survey:not(.ops-page--survey-detail) {
  --survey-ink: #222521;
  --survey-muted: #747971;
  --survey-line: #e1e3dd;
  --survey-line-soft: #eceee9;
  --survey-canvas: var(--ops-canvas);
  --survey-surface: #ffffff;
  --survey-orange: #df5935;
  --survey-orange-soft: #fff1eb;
  --survey-green: #647b5d;
  --survey-green-soft: #eef3eb;
  --survey-slate: #59645e;
  min-height: 100vh;
  color: var(--survey-ink);
  background: var(--survey-canvas);
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-shell {
  width: min(100% - 64px, 1480px);
  max-width: 1480px;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-header {
  border-bottom: 1px solid #e2e3dc;
  background: #fafaf8;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-heading {
  display: grid;
  gap: 7px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin: 0;
  color: var(--survey-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-eyebrow i {
  font-size: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .reviewops-page-title {
  margin: 0;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-heading > p:last-child {
  margin: 0;
  color: #6e746d;
  font-size: 13px;
  font-weight: 600;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-create-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 22px;
  border: 1px solid #c94726;
  color: #fff;
  background: var(--survey-orange);
  box-shadow: 0 8px 18px rgba(157, 57, 29, 0.13);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-create-button:hover {
  background: #ca4a29;
  box-shadow: 0 10px 22px rgba(157, 57, 29, 0.2);
  transform: translateY(-1px);
}

.survey-control-overview {
  display: grid;
  grid-template-columns: 1.28fr repeat(4, minmax(150px, 1fr));
  overflow: hidden;
  border: 1px solid var(--survey-line);
  border-radius: 16px;
  background: var(--survey-surface);
  box-shadow: 0 8px 28px rgba(31, 38, 31, 0.045);
}

.survey-control-overview__intro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  min-height: 126px;
  padding: 24px 26px;
  color: #fff;
  background: #30352f;
}

.survey-control-overview__intro > div {
  display: grid;
  gap: 6px;
}

.survey-control-overview__intro span {
  color: #cfd5ca;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.survey-control-overview__intro strong {
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.survey-control-overview__intro p {
  margin: 0;
  color: #c1c6be;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.survey-control-overview__intro > i {
  display: grid;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 13px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  font-size: 20px;
}

.survey-control-metric {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  min-height: 126px;
  padding: 23px 20px;
  border-left: 1px solid var(--survey-line-soft);
  background: #fff;
}

.survey-control-metric::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  background: var(--metric-color, #687b62);
  content: "";
  opacity: 0.7;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.22s ease;
}

.survey-control-metric:hover::after {
  transform: scaleX(1);
}

.survey-control-metric--live {
  --metric-color: #6f8568;
  --metric-soft: #eef3eb;
}

.survey-control-metric--draft {
  --metric-color: #9b7568;
  --metric-soft: #f6efec;
}

.survey-control-metric--question {
  --metric-color: #7a7190;
  --metric-soft: #f1eff6;
}

.survey-control-metric--project {
  --metric-color: #58766c;
  --metric-soft: #edf3f1;
}

.survey-control-metric__icon {
  display: grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 11px;
  color: var(--metric-color);
  background: var(--metric-soft);
  font-size: 15px;
}

.survey-control-metric > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.survey-control-metric small {
  color: #70766f;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-metric strong {
  color: #292d28;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.035em;
  line-height: 1.15;
}

.survey-control-metric div span {
  overflow: hidden;
  color: #979b95;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger {
  border: 1px solid var(--survey-line);
  background: var(--survey-surface);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__header {
  border: 0;
  background: #fff;
}

.survey-control-ledger__heading {
  display: grid;
  min-width: 230px;
  gap: 3px;
}

.survey-control-ledger__heading > p {
  margin: 0;
  color: var(--survey-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.survey-control-ledger__heading > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.survey-control-ledger__heading h2 {
  margin: 0;
  color: #252825;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.survey-control-ledger__heading > div > span {
  display: inline-grid;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  place-items: center;
  border-radius: 999px;
  color: #6d736c;
  background: #f0f1ed;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-ledger__heading > small {
  color: #8a8f88;
  font-size: 12px;
  font-weight: 600;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-search,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  margin: 0;
  border: 1px solid #dcded8;
  border-radius: 9px;
  background: #fbfbfa;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-search:focus-within,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select:focus-within {
  border-color: #8c9b85;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(103, 126, 94, 0.1);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-search > i,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select > i {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #7f877f;
  font-size: 12px;
  pointer-events: none;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-search input,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select select {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 38px;
  border: 0;
  outline: 0;
  color: #3e433e;
  background: transparent;
  box-shadow: none;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select select {
  padding-right: 30px;
  appearance: none;
  cursor: pointer;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-select::after {
  position: absolute;
  right: 13px;
  color: #777e76;
  content: "⌄";
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
  transform: translateY(-1px);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-search button {
  position: absolute;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  padding: 0;
  place-items: center;
  border: 0;
  color: #858b84;
  background: #eff0ed;
  cursor: pointer;
}

.survey-control-tabs {
  border-top: 1px solid #f1f2ee;
  border-bottom: 1px solid var(--survey-line);
  background: #fafaf8;
}

.survey-control-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid transparent;
  color: #747a73;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease;
}

.survey-control-tabs button:hover {
  color: #3f463e;
  background: #f0f1ed;
}

.survey-control-tabs button.is-active {
  border-color: #d8dfd4;
  color: #344030;
  background: #eef2eb;
}

.survey-control-tabs button em {
  display: inline-grid;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  place-items: center;
  color: #7b817a;
  background: #eaebe7;
  font-style: normal;
}

.survey-control-tabs button.is-active em {
  color: #fff;
  background: #667b60;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 0;
  padding: 8px 16px;
  flex-wrap: wrap;
  border-bottom: 1px solid #eceee9;
  color: #8b9089;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta strong {
  color: #343934;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta i {
  color: #9ba099;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  padding: 0;
  border: 0;
  color: #d65331;
  background: transparent;
  cursor: pointer;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table {
  width: 100%;
  min-width: 1050px;
  table-layout: fixed;
  border-collapse: collapse;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th {
  height: 43px;
  padding: 0 14px;
  border-bottom: 1px solid #e9ebe6;
  color: #828780;
  background: #f8f9f7;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  text-align: left;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:first-child,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table td:first-child {
  width: 30%;
  padding-left: 24px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(2) {
  width: 9%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(3) {
  width: 9%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(4) {
  width: 14%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(5) {
  width: 11%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(6) {
  width: 11%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(7) {
  width: 16%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row {
  position: relative;
  height: 116px;
  border: 0;
  outline: 0;
  background: #fff;
  cursor: pointer;
  transition: background 0.18s ease, box-shadow 0.18s ease;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row:hover,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row:focus-visible {
  background: #fcfcf9;
  box-shadow: inset 3px 0 0 var(--survey-orange);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row td {
  height: 116px;
  padding: 15px 14px;
  border: 0;
  border-bottom: 1px solid #e8eae5;
  color: #3f443f;
  vertical-align: middle;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 14px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-mark {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid #dbe1d8;
  border-radius: 12px;
  color: #61705e;
  background: #f2f5f0;
  font-size: 16px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-mark.status-draft {
  border-color: #eadfd9;
  color: #997064;
  background: #f8f1ee;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity strong {
  overflow: hidden;
  color: #2d312d;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity p {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: #8d928c;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity p em {
  padding: 3px 7px;
  border-radius: 999px;
  color: #697167;
  background: #f0f2ed;
  font-style: normal;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity small {
  overflow: hidden;
  max-width: 310px;
  color: #a0a49e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid #d8e1d4;
  border-radius: 999px;
  color: #5f7658;
  background: #f3f7f1;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-status.status-draft {
  border-color: #eadbd4;
  color: #a76b59;
  background: #fff6f2;
}

.survey-control-version-cell {
  display: grid;
  justify-items: start;
  gap: 5px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-version {
  display: inline-grid;
  min-width: 42px;
  height: 26px;
  padding: 0 9px;
  place-items: center;
  border: 1px solid #efded7;
  border-radius: 7px;
  color: #cf5535;
  background: #fff4ef;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-version-cell small {
  color: #999e98;
  font-size: 12px;
  font-weight: 600;
}

.survey-control-coverage {
  display: grid;
  grid-template-columns: repeat(2, minmax(48px, 1fr));
  overflow: hidden;
  max-width: 145px;
  border: 1px solid #e5e7e2;
  border-radius: 9px;
  background: #fafbf9;
}

.survey-control-coverage > span {
  display: grid;
  min-height: 50px;
  padding: 8px 9px;
  align-content: center;
  gap: 1px;
}

.survey-control-coverage > span + span {
  border-left: 1px solid #e5e7e2;
}

.survey-control-coverage small {
  color: #979c96;
  font-size: 12px;
  font-weight: 700;
}

.survey-control-coverage strong {
  color: #343934;
  font-size: 13px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-owner {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-owner > span {
  display: grid;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 50%;
  color: #596b55;
  background: #edf2e9;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-owner > div,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-date {
  display: grid;
  gap: 2px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-owner strong,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-date strong {
  color: #484d48;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-owner small,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-date small {
  color: #a1a59f;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-actions {
  display: grid;
  grid-template-columns: minmax(102px, 1fr) 34px;
  gap: 7px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.18s ease, color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next {
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #30342f;
  color: #fff;
  background: #30342f;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next:hover {
  background: #1f221f;
  transform: translateY(-1px);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next i:last-child {
  font-size: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-more {
  width: 34px;
  padding: 0;
  border: 1px solid #dfe1dc;
  color: #777d76;
  background: #fff;
  font-size: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-more:hover,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-more.is-open {
  border-color: #d96848;
  color: #cf5333;
  background: #fff5f1;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-history td {
  padding: 0;
  border-bottom: 1px solid #dde1da;
  background: #f7f8f5;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history {
  margin: 14px 24px 20px;
  padding: 18px;
  border: 1px solid #dfe3dc;
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 14px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary__icon {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 9px;
  color: #61715d;
  background: #eef2eb;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary strong {
  display: block;
  color: #343934;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary p {
  margin: 2px 0 0;
  color: #979c96;
  font-size: 12px;
  font-weight: 600;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-summary__count {
  padding: 6px 9px;
  border-radius: 999px;
  color: #6d746c;
  background: #f0f2ed;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-history-grid {
  display: grid;
  grid-template-columns: 90px 110px 90px minmax(240px, 1fr) 72px;
  align-items: center;
  min-height: 37px;
  padding: 0 12px;
  column-gap: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history__head {
  border-radius: 7px;
  color: #8c918b;
  background: #f6f7f4;
  font-size: 12px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history__item {
  border-bottom: 1px solid #eff0ed;
  color: #666c65;
  font-size: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history__item:last-child {
  border-bottom: 0;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history__item p {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-inline-history__item strong.is-active {
  color: #d65331;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-empty {
  display: grid;
  min-height: 310px;
  padding: 48px 24px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: #858b84;
  background: #fff;
  text-align: center;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-empty > span {
  display: grid;
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  place-items: center;
  border: 1px solid #e2e5df;
  border-radius: 16px;
  color: #727d70;
  background: #f4f6f1;
  font-size: 20px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-empty > strong {
  color: #3b403b;
  font-size: 13px;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-empty p {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-empty button {
  min-height: 34px;
  margin-top: 8px;
  padding: 0 14px;
  border: 1px solid #d8dcd5;
  color: #4f584e;
  background: #fff;
  cursor: pointer;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer {
  border: 0;
  background: #fbfbf9;
  color: #8d928c;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer > strong {
  color: #666c65;
  font-weight: 700;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer > span {
  justify-self: end;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer nav {
  display: flex;
  gap: 5px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer button {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  place-items: center;
  border: 1px solid #e0e3dd;
  color: #747a73;
  background: #fff;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer button.is-active {
  border-color: #df5935;
  color: #d64f2e;
  background: #fff8f5;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer button:disabled {
  color: #c7cbc5;
  background: #f5f6f3;
}

/* Create dialog refinement */
.ops-page--survey ~ .ops-modal-backdrop .ops-modal {
  overflow: hidden;
  border: 1px solid #dfe2dc;
  border-radius: 16px;
  box-shadow: 0 28px 80px rgba(29, 34, 28, 0.22);
}

.ops-page--survey ~ .ops-modal-backdrop .ops-modal__header {
  padding: 24px 26px 20px;
  border-bottom: 1px solid #e7e9e4;
  background: #fafbf8;
}

.ops-page--survey ~ .ops-modal-backdrop .ops-modal__header p {
  color: #d65331;
  letter-spacing: 0.13em;
}

.ops-page--survey ~ .ops-modal-backdrop .ops-modal__footer {
  padding: 16px 26px 22px;
  border-top: 1px solid #eceee9;
  background: #fafbf8;
}

.ops-page--survey ~ .ops-modal-backdrop .ops-modal-submit {
  border-color: #c94b2a;
  background: #df5935;
}

@media (max-width: 1220px) {
  .survey-control-overview {
    grid-template-columns: 1.3fr repeat(2, 1fr);
  }
  .survey-control-overview__intro {
    grid-row: span 2;
  }
  .survey-control-metric {
    min-height: 90px;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-identity small {
    display: none;
  }
}
@media (max-width: 920px) {
  .ops-page--survey:not(.ops-page--survey-detail) .ops-shell {
    width: min(100% - 36px, 1480px);
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions,
  .ops-page--survey:not(.ops-page--survey-detail) .survey-create-button {
    width: 100%;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-mobile {
    background: #f7f8f5;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card {
    display: grid;
    gap: 14px;
    padding: 18px;
    border: 1px solid #e0e3dc;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(31, 38, 31, 0.035);
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card > header {
    display: grid;
    grid-template-columns: 44px minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
  }
  .survey-control-card__identity {
    min-width: 0;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card h3 {
    overflow: hidden;
    margin: 6px 0 2px;
    color: #2f342f;
    font-size: 13px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card header p,
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__purpose {
    margin: 0;
    color: #90958f;
    font-size: 12px;
    font-weight: 600;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__purpose {
    padding: 10px 12px;
    border-radius: 8px;
    background: #f7f8f5;
    line-height: 1.55;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin: 0;
    overflow: hidden;
    border: 1px solid #e5e7e2;
    border-radius: 9px;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts > div {
    display: grid;
    min-height: 55px;
    padding: 9px 11px;
    align-content: center;
    gap: 3px;
    border-right: 1px solid #e5e7e2;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts > div:last-child {
    border-right: 0;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts dt {
    color: #999e98;
    font-size: 12px;
    font-weight: 700;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts dd {
    margin: 0;
    color: #3f443f;
    font-size: 12px;
    font-weight: 700;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions button {
    min-height: 38px;
    padding: 0 15px;
    border: 1px solid #dfe2dc;
    color: #596059;
    background: #fff;
    cursor: pointer;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions button:first-child {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-color: #30342f;
    color: #fff;
    background: #30342f;
  }
}
/* Questionnaire row actions ------------------------------------------------ */
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table-wrap.has-action-menu {
  z-index: 3;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row.has-action-menu {
  z-index: 30;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-row.has-action-menu > td:last-child {
  position: relative;
  z-index: 31;
}

.survey-control-action-menu-wrap {
  position: relative;
  width: 36px;
  min-width: 36px;
}

.survey-control-action-menu-wrap.is-open {
  z-index: 40;
}

.survey-control-action-menu {
  position: absolute;
  z-index: 41;
  top: calc(100% + 7px);
  right: 0;
  width: 154px;
  overflow: hidden;
  padding: 5px;
  border: 1px solid #dde1da;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(34, 40, 34, 0.16), 0 2px 6px rgba(34, 40, 34, 0.08);
}

.survey-control-action-menu button {
  width: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 10px;
  border: 0;
  color: #4f554f;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.survey-control-action-menu button:hover,
.survey-control-action-menu button:focus-visible {
  color: #30342f;
  background: #f3f5f1;
  outline: 0;
}

.survey-control-action-menu button.is-danger {
  color: #b7442b;
}

.survey-control-action-menu button.is-danger:hover,
.survey-control-action-menu button.is-danger:focus-visible {
  color: #a63823;
  background: #fff0eb;
}

.survey-control-action-menu button:disabled,
.survey-control-card__delete:disabled,
.survey-inspector__danger button:disabled {
  cursor: wait;
  opacity: 0.55;
}

@media (max-width: 920px) {
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions .survey-control-card__delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-color: #efd6cf;
    color: #b7442b;
    background: #fff8f5;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions .survey-control-card__delete:hover {
    border-color: #dfa897;
    background: #fff0eb;
  }
}
@media (max-width: 480px) {
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions {
    grid-template-columns: 1fr 1fr;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions .survey-control-card__delete {
    grid-column: 1/-1;
  }
}
/* Brighter survey management surfaces */
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-metric,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__header {
  border-color: #e3e7e1 !important;
  background: #fff !important;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview__intro {
  color: var(--survey-ink);
  background: #fff7f2 !important;
  box-shadow: inset 4px 0 0 var(--survey-orange);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview__intro span {
  color: var(--survey-orange);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview__intro strong {
  color: var(--survey-ink);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview__intro p {
  color: var(--survey-muted);
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-overview__intro > i {
  border-color: #f1d9cd;
  color: var(--survey-orange);
  background: #fff;
}

@media (max-width: 660px) {
  .ops-page--survey:not(.ops-page--survey-detail) .ops-shell {
    width: min(100% - 24px, 1480px);
  }
  .survey-control-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .survey-control-overview__intro {
    grid-column: 1/-1;
    grid-row: auto;
    min-height: 112px;
  }
  .survey-control-metric {
    min-height: 92px;
    padding: 16px;
  }
  .survey-control-metric:nth-child(2),
  .survey-control-metric:nth-child(4) {
    border-left: 0;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta {
    gap: 10px;
    padding: 0 16px;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta span:nth-child(2) {
    display: none;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card > header {
    grid-template-columns: 40px minmax(0, 1fr);
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card > header > .survey-control-version-cell {
    grid-column: 2;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts > div:nth-child(2) {
    border-right: 0;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__facts > div:nth-child(-n+2) {
    border-bottom: 1px solid #e5e7e2;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer nav {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .survey-control-metric::after,
  .ops-page--survey:not(.ops-page--survey-detail) .survey-create-button,
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-row,
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-next {
    transition: none;
  }
}
/* Survey list action — keep both icons compact so the label never collapses. */
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:first-child,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table td:first-child {
  width: 28%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th:nth-child(7) {
  width: 18%;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-actions {
  width: 100%;
  min-width: 0;
  grid-template-columns: minmax(118px, 1fr) 36px;
  gap: 8px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next {
  display: grid;
  width: 100%;
  min-width: 118px;
  grid-template-columns: 16px minmax(max-content, 1fr) 12px;
  align-items: center;
  justify-items: center;
  gap: 8px;
  padding: 0 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next i:first-child,
.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next i:last-child {
  width: auto;
  min-width: 0;
  flex: none;
  text-align: center;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-next span {
  width: auto;
  min-width: max-content;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-more {
  width: 36px;
  min-width: 36px;
}

@media (max-width: 1180px) {
  .ops-page--survey:not(.ops-page--survey-detail) .survey-control-table {
    min-width: 1120px;
  }
}
/* Survey list header — compact and align title/action to one visual baseline. */
.ops-page--survey:not(.ops-page--survey-detail) .ops-heading {
  gap: 5px;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-eyebrow {
  font-size: 12px;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-heading > p:last-child {
  font-size: 12px;
  line-height: 1.45;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions {
  align-self: center;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions .survey-create-button {
  min-height: 42px;
  padding: 0 19px;
}

@media (max-width: 920px) {
  .ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions {
    align-self: stretch;
  }
}
/* Unified operations header ------------------------------------------------ */
.ops-page--survey:not(.ops-page--survey-detail) .ops-header__inner {
  margin-inline: auto;
  box-sizing: border-box;
}

.ops-page--survey:not(.ops-page--survey-detail) .ops-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-control-eyebrow {
  font-size: 12px;
  line-height: 1.2;
}

.ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions {
  align-self: center;
  margin-left: auto;
  flex: 0 0 auto;
}

@media (max-width: 920px) {
  .ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
  .ops-page--survey:not(.ops-page--survey-detail) .survey-header-actions .survey-create-button {
    width: 100%;
  }
}
/* Survey detail border geometry ------------------------------------------- */
.ops-page--survey-detail {
  --survey-workspace-line: #dfe3dd;
  --survey-workspace-radius: 12px;
  --survey-outline-width: 168px;
  --survey-inspector-width: 248px;
  --survey-toolbar-height: 48px;
}

/* The review shell lives outside this Angular component. Use host-context so
   these corrections survive view encapsulation and override the shared card
   treatment applied to the three workspace columns. */
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-detail {
  overflow: hidden;
  border: 1px solid var(--survey-workspace-line) !important;
  border-radius: var(--survey-workspace-radius) !important;
  background: #fff !important;
  box-shadow: 0 8px 24px rgba(37, 43, 37, 0.06);
  isolation: isolate;
  animation: none;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace-header.reviewops-unified-detail-bar {
  grid-template-columns: var(--survey-outline-width) minmax(0, 1fr) auto;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid var(--survey-workspace-line) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace-header__back {
  margin: 0 !important;
  border: 0 !important;
  border-right: 1px solid var(--survey-workspace-line) !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace {
  grid-template-columns: var(--survey-outline-width) minmax(520px, 1fr) var(--survey-inspector-width);
  gap: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
  outline: 0 !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-outline-collapsed {
  grid-template-columns: 48px minmax(520px, 1fr) var(--survey-inspector-width);
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-outline,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector {
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: 0 !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-outline,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document {
  border-right: 1px solid var(--survey-workspace-line) !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-outline {
  background: #f7f8f8 !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document {
  grid-template-rows: var(--survey-toolbar-height) minmax(0, 1fr);
  background: #e9ecef !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector {
  gap: 0 !important;
  background: #fff !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-outline__header,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document-toolbar {
  height: var(--survey-toolbar-height) !important;
  min-height: var(--survey-toolbar-height) !important;
  max-height: var(--survey-toolbar-height) !important;
  margin: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid var(--survey-workspace-line) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-outline__header button,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document-toolbar button,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-document-toolbar a {
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section {
  margin: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid var(--survey-workspace-line) !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section:last-child {
  border-bottom: 0 !important;
}

@media (max-width: 1180px) {
  .ops-page--survey-detail {
    --survey-outline-width: 132px;
    --survey-inspector-width: 220px;
  }
}
@media (max-width: 940px) {
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace-header.reviewops-unified-detail-bar {
    grid-template-columns: 116px minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace,
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-outline-collapsed {
    grid-template-columns: 116px minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-document {
    border-right: 0 !important;
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector {
    border-top: 1px solid var(--survey-workspace-line) !important;
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section {
    border-right: 1px solid var(--survey-workspace-line) !important;
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section:nth-child(3n) {
    border-right: 0 !important;
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section:nth-last-child(-n+3) {
    border-bottom: 0 !important;
  }
}
@media (max-width: 640px) {
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace-header.reviewops-unified-detail-bar {
    grid-template-columns: auto minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace,
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-outline-collapsed {
    grid-template-columns: minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section {
    border-right: 0 !important;
    border-bottom: 1px solid var(--survey-workspace-line) !important;
  }
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-inspector__section:last-child {
    border-bottom: 0 !important;
  }
}
/* Native questionnaire detail: show the registered version itself instead of
   substituting the legacy sample PDF when no document was uploaded. */
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-native-survey,
:host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-native-survey.is-outline-collapsed {
  grid-template-columns: minmax(0, 1fr) var(--survey-inspector-width);
  align-items: stretch;
  height: 100%;
  min-height: 0;
}

.survey-native-document {
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  padding: 28px;
  background: #f6f8f5;
  border-right: 1px solid var(--survey-workspace-line);
}

.survey-native-document__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
  padding: 22px 24px;
  border: 1px solid #dce4da;
  border-radius: 14px;
  background: #fff;
}

.survey-native-document__header p,
.survey-native-document__header h3,
.survey-native-document__header span {
  margin: 0;
}

.survey-native-document__header p,
.survey-native-result header small {
  color: #d85b38;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.survey-native-document__header h3 {
  margin-top: 5px;
  color: #28322c;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.survey-native-document__header span {
  display: block;
  margin-top: 7px;
  color: #7e8881;
  font-size: 12px;
}

.survey-native-document__header em {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  color: #4f6c55;
  background: #edf4eb;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.survey-native-questions {
  display: grid;
  gap: 10px;
}

.survey-native-questions > article {
  padding: 17px 18px;
  border: 1px solid #dfe5dd;
  border-radius: 12px;
  background: #fff;
}

.survey-native-questions > article > header {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 11px;
  align-items: start;
}

.survey-native-questions > article > header b {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  color: #52705a;
  background: #edf4eb;
  border-radius: 9px;
  font-size: 12px;
}

.survey-native-questions small {
  color: #758078;
  font-size: 12px;
  font-weight: 700;
}

.survey-native-questions h4 {
  margin: 4px 0 0;
  color: #2d3731;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.survey-native-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 13px 0 0 41px;
}

.survey-native-options span,
.survey-native-result dd span {
  padding: 6px 9px;
  color: #617067;
  background: #f5f7f4;
  border: 1px solid #e1e6df;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.survey-native-result {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #eadfd7;
  border-radius: 12px;
  background: #fff;
}

.survey-native-result > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 15px 18px;
  background: #fff8f4;
  border-bottom: 1px solid #eadfd7;
}

.survey-native-result h4 {
  margin: 3px 0 0;
  color: #343b36;
  font-size: 13px;
}

.survey-native-result header em {
  color: #9a7769;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.survey-native-result dl,
.survey-native-result dl div {
  margin: 0;
}

.survey-native-result dl div {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  border-top: 1px solid #edf0ec;
}

.survey-native-result dl div:first-child {
  border-top: 0;
}

.survey-native-result dt {
  padding: 14px 16px;
  color: #6f7972;
  background: #fafbf9;
  font-size: 12px;
  font-weight: 700;
}

.survey-native-result dd {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 11px 14px;
}

@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-native-survey,
  :host-context(.reviewops-shell) .ops-page--survey-detail .survey-workspace.is-native-survey.is-outline-collapsed {
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }
  .survey-native-document {
    height: auto;
    border-right: 0;
  }
}
@media (max-width: 640px) {
  .survey-native-document {
    min-height: 0;
    padding: 14px;
  }
  .survey-native-document__header {
    align-items: stretch;
    flex-direction: column;
    padding: 18px;
  }
  .survey-native-result dl div {
    grid-template-columns: 1fr;
  }
}
.survey-outline__pages::-webkit-scrollbar,
.survey-document-viewer::-webkit-scrollbar,
.survey-native-document::-webkit-scrollbar,
.survey-inspector::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.survey-outline__pages::-webkit-scrollbar-track,
.survey-document-viewer::-webkit-scrollbar-track,
.survey-native-document::-webkit-scrollbar-track,
.survey-inspector::-webkit-scrollbar-track {
  background: transparent;
}

.survey-outline__pages::-webkit-scrollbar-thumb,
.survey-document-viewer::-webkit-scrollbar-thumb,
.survey-native-document::-webkit-scrollbar-thumb,
.survey-inspector::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #b9bdb7;
}

/* Survey document upload --------------------------------------------------- */
.ops-modal-backdrop .ops-modal {
  width: min(530px, 100vw - 40px);
  max-height: calc(100vh - 40px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  margin: auto;
}

.ops-page--survey + .ops-modal-backdrop {
  display: grid;
  place-items: center;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.ops-modal-backdrop .ops-modal__body {
  overflow-y: auto;
}

.survey-upload-zone {
  position: relative;
  min-height: 92px;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 16px;
  border: 1px dashed #c9cec4;
  border-radius: 10px;
  color: #555b54;
  background: #fafbf9;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.survey-upload-zone:hover,
.survey-upload-zone.is-dragging {
  border-color: #d95a37;
  background: #fff6f2;
  box-shadow: 0 0 0 3px rgba(217, 90, 55, 0.08);
}

.survey-upload-zone.has-file {
  border-style: solid;
  border-color: #bfcab8;
  background: #f6f9f4;
}

.survey-upload-zone > input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.survey-upload-zone__icon {
  width: 42px;
  height: 42px;
  display: grid;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 10px;
  color: #cf5635;
  background: #fff0e9;
  font-size: 17px;
}

.survey-upload-zone.has-file .survey-upload-zone__icon {
  color: #56734c;
  background: #eaf2e6;
}

.survey-upload-zone__copy {
  min-width: 0;
  display: grid;
  gap: 5px;
  padding-right: 28px;
}

.survey-upload-zone__copy strong,
.survey-upload-zone__copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-upload-zone__copy strong {
  color: #383d38;
  font-size: 12px;
  font-weight: 700;
}

.survey-upload-zone__copy small {
  color: #898e87;
  font-size: 12px;
}

.survey-upload-zone__remove {
  position: absolute;
  top: 50%;
  right: 12px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  color: #747a73;
  background: transparent;
  cursor: pointer;
  transform: translateY(-50%);
}

.survey-upload-zone__remove:hover {
  color: #b7442b;
  background: #ffe9e2;
}

.survey-upload-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: #b7442b;
  font-size: 12px;
  font-weight: 700;
}

.ops-form-field input.is-invalid {
  border-color: #cf6048 !important;
  outline: 2px solid rgba(207, 96, 72, 0.12);
}

.survey-name-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: -7px 0 0;
  color: #b7442b;
  font-size: 12px;
  font-weight: 700;
}

.ops-modal-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.ops-modal__footer button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  transform: none;
  box-shadow: none;
}

/* Styled questionnaire category menu and single-line list separators. */
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter {
  position: relative;
  width: 100%;
  height: 42px;
  min-width: 0;
  overflow: visible;
  border: 1px solid #dcded8;
  border-radius: 8px;
  color: #5f675f;
  background: #fbfbfa;
  box-shadow: none;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter.is-open,
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter:focus-within {
  border-color: #8c9b85;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(103, 126, 94, 0.1);
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__trigger {
  width: 100%;
  height: 40px;
  min-height: 40px;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) 12px;
  align-items: center;
  gap: 9px;
  padding: 0 13px;
  border: 0 !important;
  color: inherit !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__trigger > i:first-child {
  color: #7f877f;
  font-size: 12px;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__trigger span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__caret {
  color: #858c85;
  font-size: 12px;
  transition: transform 0.16s ease;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter.is-open .survey-category-filter__caret {
  transform: rotate(180deg);
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 80;
  width: max(100%, 220px);
  display: grid;
  gap: 2px;
  padding: 6px;
  overflow: hidden;
  border: 1px solid #d9ddd7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(35, 42, 36, 0.16);
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu button {
  width: 100%;
  min-height: 38px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  padding: 0 11px;
  border: 0 !important;
  color: #3f463f !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu button i {
  color: transparent;
  font-size: 12px;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu button:hover,
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu button.is-selected {
  color: #3f5946 !important;
  background: #eef3ee !important;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-category-filter__menu button.is-selected i {
  color: #4f725c;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-ledger__meta,
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-table thead,
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-row {
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-table thead {
  border: 0 !important;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-table th {
  border-top: 0 !important;
}

/* Keep the catalog controls compact; common registration happens in QA projects. */
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-search {
  justify-self: end;
}

/* The footer owns the final divider; avoid a second line from the last row. */
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-table tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer nav button,
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-footer nav button.is-active {
  outline: 0 !important;
  box-shadow: none !important;
}

/* Keep the two remaining row actions separated and easy to scan. */
:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-actions {
  grid-template-columns: minmax(108px, 1fr) 68px;
  column-gap: 12px !important;
  padding-inline: 6px;
  box-sizing: border-box;
}

.survey-control-common,
.survey-control-common-state {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #cdded2;
  border-radius: 8px;
  color: #426b50;
  background: #f4faf6;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

button.survey-control-common {
  cursor: pointer;
}

button.survey-control-common:hover:not(:disabled) {
  border-color: #7ca48a;
  background: #eaf5ed;
}

button.survey-control-common:disabled {
  cursor: wait;
  opacity: 0.55;
}

.survey-workspace-header__actions .survey-control-common,
.survey-workspace-header__actions .survey-control-common-state {
  min-height: 40px;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-delete {
  width: 68px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #e2c4bc;
  border-radius: 8px;
  color: #a14f3f;
  background: #fff;
  box-shadow: none !important;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-delete:hover:not(:disabled) {
  border-color: #c87967;
  color: #8a3c2e;
  background: #fff3ef;
}

:host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-delete:disabled {
  cursor: wait;
  opacity: 0.55;
}

@media (max-width: 920px) {
  :host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions {
    grid-template-columns: minmax(0, 1fr) auto;
  }
}
@media (max-width: 480px) {
  :host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions {
    grid-template-columns: minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ops-page--survey:not(.ops-page--survey-detail) .survey-control-card__actions .survey-control-card__delete {
    grid-column: auto;
  }
}
/* One native list, with independent delete actions. Both widths share one DOM. */
.survey-record-head, .survey-record {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(90px, 0.7fr);
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
}

.survey-record-head {
  background: #F6F7F5;
  color: #526052;
  padding-right: 100px;
}

.survey-record-shell {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #D9DFD7;
}

.survey-record {
  min-width: 0;
  flex: 1;
  color: #202420;
  text-decoration: none;
}

.survey-record > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.survey-record :is(p, small) {
  display: block;
  margin: 4px 0 0;
}

.survey-record:hover {
  background: #F6F7F5;
}

.survey-record-identity strong {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.survey-record-action {
  font-weight: 600;
  color: #8F351D;
}

.survey-record-delete {
  flex: 0 0 auto;
  margin-right: 16px;
}

@media (max-width: 1023px) {
  .survey-record-head {
    display: none;
  }
  .survey-record-shell {
    display: grid;
    margin: 16px;
    border: 1px solid #D9DFD7;
    border-radius: 12px;
  }
  .survey-record {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 16px;
  }
  .survey-record-identity, .survey-record-action {
    grid-column: 1/-1;
  }
  .survey-record-delete {
    justify-self: end;
    margin: 0 16px 16px;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .ops-page--survey .survey-native-document {
  padding: 24px;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-native-questions {
  max-width: 80ch;
  margin-inline: auto;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-native-questions h4 {
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-workspace-header__title {
  min-width: 0;
  flex: 1 1 240px;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-workspace-header__title dl {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-workspace-header__title dd {
  margin: 0;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-inspector {
  position: static;
  padding: 16px;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-inspector__section {
  padding: 16px 0;
}
:host-context(.reviewops-shell) .ops-page--survey .survey-inspector__summary {
  gap: 12px;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .ops-page--survey.ops-page--survey-detail {
    height: auto;
    overflow: visible;
  }
  :host-context(.reviewops-shell) .ops-page--survey.ops-page--survey-detail .survey-detail {
    height: auto;
    min-height: 0;
    grid-template-rows: auto;
    overflow: visible;
  }
  :host-context(.reviewops-shell) .ops-page--survey .survey-workspace {
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 0;
    overflow: visible;
    gap: 16px;
  }
  :host-context(.reviewops-shell) .ops-page--survey .survey-native-document, :host-context(.reviewops-shell) .ops-page--survey .survey-inspector {
    width: 100%;
    height: auto;
    max-height: none;
    overflow: visible;
  }
  :host-context(.reviewops-shell) .ops-page--survey .survey-document {
    min-height: 480px;
  }
  :host-context(.reviewops-shell) .ops-page--survey .survey-outline {
    max-height: 240px;
  }
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .ops-page--survey .survey-native-document {
    padding: 16px;
  }
}`],
})
export class PageSurveysComponent implements OnInit {
    public keyword: string = '';
    public status: string = '전체';
    public categoryFilter: string = '전체';
    public categoryMenuOpen: boolean = false;
    public surveyPage: number = 1;
    public readonly surveyPageSize: number = 10;
    public showCreateModal: boolean = false;
    public deletingSurveyId: string = '';
    public surveyUploadDragActive: boolean = false;
    public surveyUploadError: string = '';
    public surveyNameError: string = '';
    public creatingSurvey: boolean = false;
    public selectedSurvey: any = null;
    public inspectorHistoryOpen: boolean = false;
    public surveyPdfPage: number = 1;
    public surveyPdfTotalPages: number = 5;
    public surveyPdfZoom: number = 100;
    public surveyPdfNonce: number = 0;
    public surveyOutlineCollapsed: boolean = false;
    public surveyPdfPages: any[] = [
        { page: 1, label: '표지' },
        { page: 2, label: '검수 흐름' },
        { page: 3, label: '검수 기준' },
        { page: 4, label: '표본 선정 기준' },
        { page: 5, label: '검수 기록 및 보고' }
    ];
    public form: any = { name: '', category: '공통 QA', description: '', document: null };
    public surveys: any[] = [];
    public uiLoading: boolean = true;
    public loadError: string = '';
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly workspaceManagementUrl: string = '/api/v1/review-workspace/management';
    private readonly surveyDocumentUploadUrl: string = '/api/v1/review-workspace/survey-document';
    private readonly defaultSurveyPdfUrl: string = '/assets/documents/northeast-asian-history-qa-review-form-v1.0.pdf';
    private surveyScrollFrame: number | null = null;
    private workspaceServerMode: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async fetchWorkspaceState() {
        const response = await fetch(this.workspaceStateUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
        const payload = await response.json();
        const state = this.normalizeWorkspaceState(payload);
        if (!state || !Array.isArray(state.surveys)) {
            throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        }
        return state;
    }

    private async mutateWorkspace(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.workspaceManagementUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        const apiCode = Number(payload?.code ?? response.status);
        const errorMessage = payload?.data?.message || payload?.message || '설문지를 서버에 저장하지 못했습니다.';
        if (!response.ok || (Number.isFinite(apiCode) && apiCode >= 400)) throw new Error(errorMessage);
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        const result = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && candidate.state && typeof candidate.state === 'object');
        if (!result || !this.normalizeWorkspaceState({ state: result.state })) {
            throw new Error('설문지 저장 응답이 올바르지 않습니다.');
        }
        return result;
    }

    private normalizeSurveyVersion(version: any, activeVersion: string) {
        const versionId = String(version?.version || version?.id || version?.name || '');
        const dimensions = Array.isArray(version?.dimensions) ? version.dimensions : [];
        const questions = Array.isArray(version?.questions)
            ? version.questions.length
            : Number(version?.questions ?? version?.questionCount ?? version?.question_count ?? 0);
        return {
            ...version,
            version: versionId,
            date: version?.date || version?.createdAt || version?.created_at || '—',
            author: version?.author || version?.owner || '미지정',
            note: version?.note || version?.description || '',
            questions,
            questionItems: Array.isArray(version?.questions) ? version.questions : (version?.questionItems || version?.question_items || []),
            dimensions,
            active: version?.active !== undefined ? !!version.active : versionId === activeVersion
        };
    }

    private dateOnlyLabel(value: any): string {
        const source = String(value || '').trim();
        if (!source || source === '—') return '—';
        const isoDate = source.match(/^(\d{4})[-./](\d{2})[-./](\d{2})/);
        if (isoDate) return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`;
        const parsed = new Date(source);
        return Number.isNaN(parsed.getTime()) ? source : parsed.toISOString().slice(0, 10);
    }

    private normalizeServerSurvey(row: any) {
        const rawVersions = Array.isArray(row?.versions) ? row.versions : [];
        const declaredActive = String(row?.activeVersion || row?.active_version || row?.version || '');
        const versions = rawVersions.map((version: any) => this.normalizeSurveyVersion(version, declaredActive));
        const active = versions.find((version: any) => version.active)
            || versions.find((version: any) => version.version === declaredActive)
            || versions[0]
            || null;
        if (active && !versions.some((version: any) => version.active)) active.active = true;
        const registeredVersion = String(
            row?.catalogVersion || row?.catalog_version || declaredActive || active?.version || 'v1.0'
        );
        const registered = versions.find((version: any) => version.version === registeredVersion) || active;
        const snapshot = registered || row;
        const questionItems = Array.isArray(snapshot?.questionItems)
            ? snapshot.questionItems
            : (Array.isArray(snapshot?.question_items)
                ? snapshot.question_items
                : (Array.isArray(snapshot?.dimensions)
                    ? snapshot.dimensions
                    : (Array.isArray(snapshot?.questions) ? snapshot.questions : [])));
        const dimensions = Array.isArray(snapshot?.dimensions) ? snapshot.dimensions : questionItems;
        const numericQuestionCount = Number(
            snapshot?.questions ?? snapshot?.questionCount ?? snapshot?.question_count ?? questionItems.length
        );
        const questionCount = Array.isArray(snapshot?.questions)
            ? snapshot.questions.length
            : (Number.isFinite(numericQuestionCount) ? numericQuestionCount : questionItems.length);

        const updated = row?.updated || row?.updatedAt || row?.updated_at || '—';
        return {
            ...row,
            id: String(row?.id || ''),
            name: row?.name || row?.title || '이름 없는 설문지',
            category: row?.category || '공통',
            activeVersion: registeredVersion,
            registeredVersion,
            sourceActiveVersion: active?.version || declaredActive || registeredVersion,
            questions: questionCount,
            questionItems,
            dimensions,
            usage: Number(row?.usage ?? row?.projectCount ?? row?.project_count ?? 0) || 0,
            owner: row?.owner || row?.author || '미지정',
            updated,
            updatedDate: this.dateOnlyLabel(updated),
            status: row?.status || '사용 중',
            purpose: row?.purpose || row?.description || '',
            description: row?.description || row?.purpose || '',
            decisionOptions: Array.isArray(snapshot?.decisionOptions) ? snapshot.decisionOptions : (row?.decisionOptions || []),
            issueOptions: Array.isArray(snapshot?.issueOptions) ? snapshot.issueOptions : (row?.issueOptions || []),
            commentFields: Array.isArray(snapshot?.commentFields) ? snapshot.commentFields : (row?.commentFields || []),
            pdfUrl: String(snapshot?.pdfUrl || snapshot?.pdf_url || row?.pdfUrl || row?.pdf_url || ''),
            pdfPages: Number(snapshot?.pdfPages ?? snapshot?.pdf_pages ?? row?.pdfPages ?? row?.pdf_pages ?? 0) || 0,
            versions
        };
    }

    private surveyProjectUsageCount(survey: any, projects: any[]) {
        const surveyId = String(survey?.id || '');
        const surveyName = String(survey?.name || '');
        const ownerProjectId = String(survey?.projectId || '');
        const connected = new Set<string>();
        projects.forEach((project: any) => {
            const projectId = String(project?.id || '');
            const qa = project?.settings?.qa || {};
            if (
                projectId && ownerProjectId === projectId
                || surveyId && String(qa?.surveyId || '') === surveyId
                || surveyName && String(qa?.survey || '') === surveyName
            ) connected.add(projectId);
        });
        return Array.from(connected).filter(Boolean).length;
    }

    private async loadWorkspaceSurveys() {
        this.uiLoading = true;
        await this.service.render();
        try {
            const state = await this.fetchWorkspaceState();
            const qaProjectIds = new Set(
                state.projects
                    .filter((project: any) => project?.outputs?.qa === true)
                    .map((project: any) => String(project?.id || ''))
                    .filter(Boolean)
            );
            this.surveys = state.surveys
                .filter((survey: any) => (
                    this.isCommonSurvey(survey)
                    && qaProjectIds.has(String(survey?.projectId || ''))
                ))
                .map((survey: any) => this.normalizeServerSurvey({
                    ...survey,
                    usage: this.surveyProjectUsageCount(survey, state.projects)
                }));
            this.workspaceServerMode = true;
            this.loadError = '';
            return true;
        } catch (error) {
            this.surveys = [];
            this.workspaceServerMode = false;
            this.loadError = error instanceof Error
                ? error.message
                : '설문지 목록을 불러오지 못했습니다.';
            return false;
        } finally {
            this.uiLoading = false;
        }
    }

    private nextSurveyId() {
        const maxId = this.surveys.reduce((max: number, survey: any) => {
            const match = String(survey.id || '').match(/^SV-(\d+)$/);
            return match ? Math.max(max, Number(match[1])) : max;
        }, 0);
        return 'SV-' + String(maxId + 1).padStart(3, '0');
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.loadWorkspaceSurveys();
        const selectedId = new URLSearchParams(location.search).get('survey');
        const selected = this.surveys.find((survey: any) => String(survey.id) === selectedId);
        if (selected) await this.openSurvey(selected);
        await this.service.render();
    }

    public async reloadWorkspaceSurveys() {
        await this.loadWorkspaceSurveys();
        await this.service.render();
    }

    public filteredSurveys() {
        const query = this.keyword.trim().toLowerCase();
        return this.surveys.filter((survey: any) => {
            const statusMatch = this.status === '전체' || survey.status === this.status;
            const categoryMatch = this.categoryFilter === '전체' || survey.category === this.categoryFilter;
            const queryMatch = !query || survey.name.toLowerCase().indexOf(query) >= 0 || survey.id.toLowerCase().indexOf(query) >= 0;
            return statusMatch && categoryMatch && queryMatch;
        });
    }

    public surveyPageCount() {
        return Math.max(1, Math.ceil(this.filteredSurveys().length / this.surveyPageSize));
    }

    public activeSurveyPage() {
        return Math.min(Math.max(1, this.surveyPage), this.surveyPageCount());
    }

    public surveyPageNumbers() {
        return Array.from({ length: this.surveyPageCount() }, (_value: unknown, index: number) => index + 1);
    }

    public pagedSurveys() {
        const start = (this.activeSurveyPage() - 1) * this.surveyPageSize;
        return this.filteredSurveys().slice(start, start + this.surveyPageSize);
    }

    public async goToSurveyPage(page: number) {
        this.surveyPage = Math.min(Math.max(1, page), this.surveyPageCount());
        await this.service.render();
    }

    public statusCount(status: string) {
        return status === '전체'
            ? this.surveys.length
            : this.surveys.filter((survey: any) => survey.status === status).length;
    }

    public categories() {
        return Array.from(new Set(this.surveys.map((survey: any) => survey.category))).sort();
    }

    public categoryOptions() {
        return ['전체', ...this.categories()];
    }

    public categoryFilterLabel() {
        return this.categoryFilter === '전체' ? '전체 분류' : this.categoryFilter;
    }

    public async toggleCategoryFilter(event?: Event) {
        event?.stopPropagation();
        this.categoryMenuOpen = !this.categoryMenuOpen;
        await this.service.render();
    }

    public async selectCategoryFilter(value: string, event?: Event) {
        event?.stopPropagation();
        this.categoryFilter = value;
        this.surveyPage = 1;
        this.categoryMenuOpen = false;
        await this.service.render();
    }

    public surveyActionLabel(survey: any) {
        if (survey.status === '사용 중') return '문항 관리';
        if (survey.status === '초안') return '이어서 작성';
        return '버전 보기';
    }

    public totalQuestions() {
        return this.surveys.reduce((total: number, survey: any) => total + survey.questions, 0);
    }

    public totalUsage() {
        return this.surveys.reduce((total: number, survey: any) => total + survey.usage, 0);
    }

    public async setStatus(status: string) {
        this.status = status;
        this.surveyPage = 1;
        await this.service.render();
    }

    public async resetFilters() {
        this.keyword = '';
        this.status = '전체';
        this.categoryFilter = '전체';
        this.surveyPage = 1;
        this.categoryMenuOpen = false;
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    public async closeCategoryMenuFromOutside(event: MouseEvent) {
        if (!this.categoryMenuOpen) return;
        const target = event.target as HTMLElement | null;
        if (this.categoryMenuOpen && !(target && target.closest('.survey-category-filter'))) {
            this.categoryMenuOpen = false;
            await this.service.render();
        }
    }

    public surveyHref(survey: any) {
        const params = new URLSearchParams(location.search);
        params.set('survey', String(survey.id));
        return '/surveys?' + params.toString();
    }

    public async followSurvey(event: MouseEvent, survey: any) {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (window.getSelection()?.toString()) return;
        event.preventDefault();
        history.replaceState(history.state, '', this.surveyHref(survey));
        await this.openSurvey(survey);
    }

    public async openSurvey(survey: any) {
        this.categoryMenuOpen = false;
        this.selectedSurvey = survey;
        this.inspectorHistoryOpen = false;
        this.surveyPdfPage = 1;
        const declaredPages = Number(survey?.pdfPages || survey?.pdf_pages || survey?.pageCount || survey?.page_count);
        if (Number.isFinite(declaredPages) && declaredPages > 0) {
            this.surveyPdfTotalPages = Math.floor(declaredPages);
        } else if (Array.isArray(survey?.pages) && survey.pages.length) {
            this.surveyPdfTotalPages = survey.pages.length;
        } else {
            this.surveyPdfTotalPages = 5;
        }
        this.surveyPdfPages = this.buildSurveyPdfPages(survey, this.surveyPdfTotalPages);
        this.surveyPdfZoom = 100;
        this.surveyOutlineCollapsed = false;
        await this.service.render();
    }

    public surveyOptionLabel(option: any) {
        if (option && typeof option === 'object') {
            const label = String(option.label || option.text || option.value || '').trim();
            return option.score !== undefined && option.score !== null
                ? `${option.score}점${label ? ' · ' + label : ''}`
                : label;
        }
        return String(option || '').trim();
    }

    public surveyIssueLabel(issue: any) {
        return String(issue?.label || issue?.text || issue?.code || issue?.value || '').trim();
    }

    private buildSurveyPdfPages(survey: any, totalPages: number) {
        const suppliedPages = Array.isArray(survey?.pages) ? survey.pages : [];
        const defaultLabels = ['표지', '검수 흐름', '검수 기준', '표본 선정 기준', '검수 기록 및 보고'];
        const source = String(survey?.pdfUrl || survey?.pdf_url || this.defaultSurveyPdfUrl).split(/[?#]/, 1)[0];
        const isDefaultDocument = source === this.defaultSurveyPdfUrl;

        return Array.from({ length: Math.max(1, totalPages) }, (_value: unknown, index: number) => {
            const page = index + 1;
            const supplied = suppliedPages[index];
            const suppliedLabel = typeof supplied === 'string'
                ? supplied
                : (supplied?.label || supplied?.title || supplied?.name || '');
            return {
                ...(supplied && typeof supplied === 'object' ? supplied : {}),
                page,
                label: suppliedLabel || (isDefaultDocument && defaultLabels[index]
                    ? defaultLabels[index]
                    : `페이지 ${page}`)
            };
        });
    }

    public async closeSurvey() {
        const params = new URLSearchParams(location.search);
        params.delete('survey');
        history.replaceState(history.state, '', '/surveys' + (params.size ? '?' + params.toString() : ''));
        this.selectedSurvey = null;
        this.inspectorHistoryOpen = false;
        await this.service.render();
    }

    public async toggleInspectorHistory() {
        this.inspectorHistoryOpen = !this.inspectorHistoryOpen;
        await this.service.render();
    }

    public openPdfFullscreen() {
        const viewer = document.getElementById('survey-pdf-viewer');
        if (viewer && viewer.requestFullscreen) viewer.requestFullscreen();
    }

    public surveyPdfThumbnailUrl(page: number): string {
        const source = this.selectedSurvey?.pdfUrl || this.defaultSurveyPdfUrl;
        const documentPath = source.split(/[?#]/, 1)[0];
        const isManagedDocument = documentPath.includes('/api/v1/review-workspace/survey-document/');
        const imagePath = isManagedDocument
            ? documentPath.replace(/document\.(?:pdf|png)$/i, `document-thumb-${page}.png`)
            : (/\.pdf$/i.test(documentPath)
            ? documentPath.replace(/\.pdf$/i, `-page-${page}.png`)
            : documentPath);
        return `${imagePath}?viewer=${this.surveyPdfNonce}`;
    }

    public surveyPdfPageImageUrl(page: number): string {
        const source = this.selectedSurvey?.pdfUrl || this.defaultSurveyPdfUrl;
        const documentPath = source.split(/[?#]/, 1)[0];
        const imagePath = /\.pdf$/i.test(documentPath)
            ? documentPath.replace(/\.pdf$/i, `-page-${page}.png`)
            : (documentPath.includes('/api/v1/review-workspace/survey-document/')
                ? documentPath.replace(/document\.png$/i, `document-page-${page}.png`)
                : documentPath);
        return `${imagePath}?viewer=${this.surveyPdfNonce}`;
    }

    public surveyPdfPageUrl(page: number = this.surveyPdfPage, zoom: number = this.surveyPdfZoom): string {
        const source = this.selectedSurvey?.pdfUrl || this.defaultSurveyPdfUrl;
        return `${source}?viewer=${this.surveyPdfNonce}#page=${page}&zoom=${zoom}&toolbar=0&navpanes=0&scrollbar=0`;
    }

    public async selectSurveyPdfPage(page: number) {
        const nextPage = Math.min(this.surveyPdfTotalPages, Math.max(1, page));
        if (nextPage !== this.surveyPdfPage) {
            this.surveyPdfPage = nextPage;
            await this.service.render();
        }
        this.scrollSurveyDocumentToPage(nextPage);
        this.scrollSurveyOutlineToPage(nextPage);
    }

    private scrollSurveyDocumentToPage(page: number) {
        if (typeof window === 'undefined') return;
        window.requestAnimationFrame(() => {
            const viewer = document.getElementById('survey-pdf-viewer');
            const target = document.getElementById(`survey-document-page-${page}`);
            if (!viewer || !target) return;
            const viewerRect = viewer.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            viewer.scrollTo({
                top: viewer.scrollTop + targetRect.top - viewerRect.top - 18,
                behavior: 'auto'
            });
        });
    }

    private scrollSurveyOutlineToPage(page: number) {
        if (typeof window === 'undefined') return;
        window.requestAnimationFrame(() => {
            const outline = document.querySelector('.survey-outline__pages') as HTMLElement | null;
            const target = document.getElementById(`survey-thumbnail-${page}`);
            if (!outline || !target) return;
            const targetTop = target.offsetTop;
            const targetBottom = targetTop + target.offsetHeight;
            const visibleTop = outline.scrollTop;
            const visibleBottom = visibleTop + outline.clientHeight;
            if (targetTop >= visibleTop + 8 && targetBottom <= visibleBottom - 8) return;
            outline.scrollTo({
                top: Math.max(0, targetTop - (outline.clientHeight - target.offsetHeight) / 2),
                behavior: 'auto'
            });
        });
    }

    public onSurveyPdfScroll(event: Event) {
        if (typeof window === 'undefined' || this.surveyScrollFrame !== null) return;
        const viewer = event.currentTarget as HTMLElement | null;
        if (!viewer) return;

        this.surveyScrollFrame = window.requestAnimationFrame(async () => {
            this.surveyScrollFrame = null;
            const viewport = viewer.getBoundingClientRect();
            const markerY = viewport.top + Math.min(viewer.clientHeight * 0.35, 240);
            const pages = Array.from(viewer.querySelectorAll('.survey-document-page')) as HTMLElement[];
            let nextPage = this.surveyPdfPage;
            let nearestDistance = Number.POSITIVE_INFINITY;

            pages.forEach((element: HTMLElement) => {
                const rect = element.getBoundingClientRect();
                const rawPage = Number(element.dataset.surveyPage || 0);
                if (!rawPage) return;
                const distance = markerY < rect.top
                    ? rect.top - markerY
                    : (markerY > rect.bottom ? markerY - rect.bottom : 0);
                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nextPage = rawPage;
                }
            });

            if (nextPage === this.surveyPdfPage) return;
            this.surveyPdfPage = nextPage;
            await this.service.render();
            this.scrollSurveyOutlineToPage(nextPage);
        });
    }

    public async changeSurveyPdfZoom(amount: number) {
        this.surveyPdfZoom = Math.min(160, Math.max(60, this.surveyPdfZoom + amount));
        await this.service.render();
        this.scrollSurveyDocumentToPage(this.surveyPdfPage);
    }

    public async refreshSurveyPdf() {
        this.surveyPdfNonce += 1;
        await this.service.render();
    }

    public async toggleSurveyOutline() {
        this.surveyOutlineCollapsed = !this.surveyOutlineCollapsed;
        await this.service.render();
    }

    public openSurveyPdfWindow() {
        if (typeof window === 'undefined') return;
        window.open(this.surveyPdfPageUrl(), '_blank', 'noopener');
    }

    public printSurveyPdf() {
        if (typeof window === 'undefined') return;
        const printWindow = window.open(this.surveyPdfPageUrl(), '_blank', 'noopener');
        if (printWindow) window.setTimeout(() => printWindow.print(), 700);
    }

    public async deleteSurvey(survey: any) {
        if (!survey || this.deletingSurveyId) return;

        if (survey.usage > 0) {
            await this.service.modal.warning(
                `'${survey.name}' 설문지는 현재 ${survey.usage}개 프로젝트에서 사용 중이어서 삭제할 수 없습니다. 프로젝트 연결을 해제한 뒤 다시 시도해주세요.`,
                false,
                '확인'
            );
            return;
        }
        if (!this.workspaceServerMode) {
            await this.service.modal.warning(
                '설문지 저장소에 연결되지 않아 삭제할 수 없습니다.', false, '확인'
            );
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '설문지 삭제',
            message: `'${survey.name}' 설문지를 삭제하시겠습니까? 삭제한 설문지와 버전 이력은 복구할 수 없습니다.`,
            cancel: '취소',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        this.deletingSurveyId = survey.id;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'surveys', action: 'delete', id: survey.id
            });
            this.surveys = result.state.surveys.map((survey: any) => this.normalizeServerSurvey(survey));
        } catch (error) {
            this.deletingSurveyId = '';
            await this.service.render();
            await this.service.modal.warning(
                error instanceof Error ? error.message : '설문지를 서버에서 삭제하지 못했습니다.',
                false,
                '확인'
            );
            return;
        }
        if (this.selectedSurvey?.id === survey.id) this.selectedSurvey = null;
        this.deletingSurveyId = '';
        await this.service.render();
        await this.service.modal.success('설문지가 삭제되었습니다.');
    }

    public isCommonSurvey(survey: any) {
        return survey?.adminDesignated === true
            || survey?.admin_designated === true
            || survey?.catalogVisible === true
            || survey?.catalog_visible === true;
    }

    public async deleteSelectedSurvey() {
        await this.deleteSurvey(this.selectedSurvey);
    }

    public async openCreate() {
        this.form = { name: '', category: '공통 QA', description: '', document: null };
        this.surveyUploadDragActive = false;
        this.surveyUploadError = '';
        this.surveyNameError = '';
        this.showCreateModal = true;
        await this.service.render();
    }

    public async closeCreate() {
        if (this.creatingSurvey) return;
        this.showCreateModal = false;
        this.surveyUploadDragActive = false;
        this.surveyUploadError = '';
        this.surveyNameError = '';
        await this.service.render();
    }

    private normalizedSurveyName(value: any): string {
        return String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('ko-KR');
    }

    public surveyNameAlreadyExists(value: any = this.form.name): boolean {
        const expected = this.normalizedSurveyName(value);
        return !!expected && this.surveys.some((survey: any) =>
            this.normalizedSurveyName(survey?.name) === expected
        );
    }

    public validateSurveyName(value: any = this.form.name) {
        const name = String(value || '').trim();
        this.surveyNameError = name && this.surveyNameAlreadyExists(value)
            ? '같은 이름의 설문지가 이미 존재합니다.'
            : '';
    }

    public formatSurveyDocumentSize(size: number) {
        if (!Number.isFinite(size) || size <= 0) return '0 KB';
        if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`;
        return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    }

    private async setSurveyDocument(file: File | null) {
        this.surveyUploadError = '';
        if (!file) {
            this.form.document = null;
            await this.service.render();
            return;
        }
        const extension = String(file.name || '').split('.').pop()?.toLowerCase();
        const allowed = ['pdf', 'png', 'jpg', 'jpeg'].includes(extension || '');
        if (!allowed) {
            this.form.document = null;
            this.surveyUploadError = 'PDF, PNG, JPG 형식의 문서만 첨부할 수 있습니다.';
        } else if (file.size > 20 * 1024 * 1024) {
            this.form.document = null;
            this.surveyUploadError = '파일 크기는 20MB 이하여야 합니다.';
        } else if (!file.size) {
            this.form.document = null;
            this.surveyUploadError = '비어 있는 파일은 첨부할 수 없습니다.';
        } else {
            this.form.document = file;
        }
        await this.service.render();
    }

    public async selectSurveyDocument(event: Event) {
        const input = event.target as HTMLInputElement | null;
        await this.setSurveyDocument(input?.files?.[0] || null);
        if (input) input.value = '';
    }

    public async removeSurveyDocument(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        await this.setSurveyDocument(null);
    }

    public async surveyDocumentDragOver(event: DragEvent) {
        event.preventDefault();
        if (this.surveyUploadDragActive) return;
        this.surveyUploadDragActive = true;
        await this.service.render();
    }

    public async surveyDocumentDragLeave(event: DragEvent) {
        event.preventDefault();
        const currentTarget = event.currentTarget as HTMLElement | null;
        const relatedTarget = event.relatedTarget as Node | null;
        if (currentTarget && relatedTarget && currentTarget.contains(relatedTarget)) return;
        if (!this.surveyUploadDragActive) return;
        this.surveyUploadDragActive = false;
        await this.service.render();
    }

    public async dropSurveyDocument(event: DragEvent) {
        event.preventDefault();
        this.surveyUploadDragActive = false;
        await this.setSurveyDocument(event.dataTransfer?.files?.[0] || null);
    }

    private async uploadSurveyDocument(file: File) {
        const body = new FormData();
        body.append('file', file, file.name);
        const response = await fetch(this.surveyDocumentUploadUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        const apiCode = Number(payload?.code ?? response.status);
        const errorMessage = payload?.data?.message
            || payload?.message
            || payload?.error?.message
            || '문서 파일을 업로드하지 못했습니다.';
        if (!response.ok || (Number.isFinite(apiCode) && apiCode >= 400)) {
            throw new Error(errorMessage);
        }

        const candidates: any[] = [payload];
        const visited = new Set<any>();
        let result: any = null;
        while (candidates.length && visited.size < 24) {
            const candidate = candidates.shift();
            if (!candidate || typeof candidate !== 'object' || visited.has(candidate)) continue;
            visited.add(candidate);
            if (candidate.url && Number.isFinite(Number(candidate.pages))) {
                result = candidate;
                break;
            }
            ['data', 'result', 'document', 'file'].forEach((key: string) => {
                if (candidate[key] && typeof candidate[key] === 'object') candidates.push(candidate[key]);
            });
        }
        if (!result?.url || !Number.isFinite(Number(result?.pages))) {
            throw new Error('문서 업로드 응답이 올바르지 않습니다.');
        }
        return result;
    }

    public async createMock() {
        if (this.creatingSurvey) return;
        if (!this.form.name.trim()) {
            this.surveyNameError = '설문지 이름을 입력해주세요.';
            await this.service.render();
            document.querySelector<HTMLInputElement>('#survey-name-input')?.focus();
            return;
        }
        if (this.surveyNameAlreadyExists()) {
            this.surveyNameError = '같은 이름의 설문지가 이미 존재합니다.';
            await this.service.render();
            document.querySelector<HTMLInputElement>('#survey-name-input')?.focus();
            return;
        }
        if (!this.workspaceServerMode) {
            await this.service.modal.warning(
                '설문지 저장소에 연결되지 않아 설문지를 만들 수 없습니다.', false, '확인'
            );
            return;
        }

        this.creatingSurvey = true;
        this.surveyUploadError = '';
        await this.service.render();
        let uploadedDocument: any = null;
        try {
            if (this.form.document) uploadedDocument = await this.uploadSurveyDocument(this.form.document);
        } catch (error) {
            this.creatingSurvey = false;
            this.surveyUploadError = error instanceof Error
                ? error.message
                : '문서 파일을 업로드하지 못했습니다.';
            await this.service.render();
            if (typeof window !== 'undefined') {
                window.requestAnimationFrame(() => {
                    document.querySelector('.survey-upload-zone')?.scrollIntoView({
                        behavior: 'smooth', block: 'center'
                    });
                });
            }
            return;
        }
        const owner = this.service.auth.session && this.service.auth.session.name
            ? this.service.auth.session.name
            : '미지정';
        const updated = new Date().toISOString();
        const extractedSchema = uploadedDocument?.survey_schema && typeof uploadedDocument.survey_schema === 'object'
            ? uploadedDocument.survey_schema
            : {};
        const extractedDimensions = Array.isArray(extractedSchema.dimensions) ? extractedSchema.dimensions : [];
        const extractedQuestionItems = Array.isArray(extractedSchema.questionItems)
            ? extractedSchema.questionItems
            : extractedDimensions;
        const extractedQuestionCount = extractedDimensions.length;
        const survey = {
            id: this.nextSurveyId(), name: this.form.name.trim(), category: this.form.category, activeVersion: 'v0.1', questions: extractedQuestionCount, usage: 0, owner, updated, status: '초안',
            description: String(this.form.description || '').trim(),
            pdfUrl: uploadedDocument?.url || this.defaultSurveyPdfUrl,
            pdfPages: Number(uploadedDocument?.pages || 5),
            questionItems: extractedQuestionItems,
            dimensions: extractedDimensions,
            decisionOptions: Array.isArray(extractedSchema.decisionOptions) ? extractedSchema.decisionOptions : [],
            issueOptions: Array.isArray(extractedSchema.issueOptions) ? extractedSchema.issueOptions : [],
            commentFields: Array.isArray(extractedSchema.commentFields) ? extractedSchema.commentFields : [],
            sourcePage: Number(extractedSchema.sourcePage) || null,
            extractionVersion: String(extractedSchema.extractionVersion || ''),
            versions: [{
                version: 'v0.1', date: updated, author: owner,
                note: extractedQuestionCount ? `PDF ${Number(extractedSchema.sourcePage) || ''}페이지 설문 문항 자동 추출` : '설문지 초안 생성',
                questions: extractedQuestionCount,
                questionItems: extractedQuestionItems,
                dimensions: extractedDimensions,
                active: true
            }]
        };
        const serverItem: any = { ...survey };
        delete serverItem.id;
        try {
            const result = await this.mutateWorkspace({ resource: 'surveys', action: 'create', item: serverItem });
            this.surveys = result.state.surveys.map((row: any) => this.normalizeServerSurvey(row));
        } catch (error) {
            this.creatingSurvey = false;
            const message = error instanceof Error ? error.message : '설문지를 서버에 저장하지 못했습니다.';
            if (message.includes('같은 이름')) {
                this.surveyNameError = message;
                await this.service.render();
                document.querySelector<HTMLInputElement>('#survey-name-input')?.focus();
                return;
            }
            await this.service.render();
            await this.service.modal.warning(
                message,
                false,
                '확인'
            );
            return;
        }
        this.creatingSurvey = false;
        this.showCreateModal = false;
        await this.service.render();
        await this.service.modal.success('설문지 초안이 추가되었습니다.');
    }

    public statusClass(status: string) {
        if (status === '사용 중') return 'status-live';
        if (status === '초안') return 'status-draft';
        return 'status-review';
    }
}

export default PageSurveysComponent;